import angular from 'angular';
import $ from 'jquery';
import _, {isObject} from 'lodash';
import date_moment_tool from "moment-business-days";

angular.module('app.services')
.directive('uiSelectNoAnimate', () => ({
    restrict: 'A',
    require: 'uiSelect',
    link: (scope, element, attrs, $select) => {
        $select.$animate = null;
    }
}))
.factory('FormFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
    var factory = {};

    factory.getLocations = function() {
        return $resource(AppConfig.IO_API_URL + 'api/geoLocations', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getFbLocations = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getFbGeoLocation', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.geoLocationsForAdwords = function() {
        return $resource(AppConfig.IO_API_URL + 'api/geoLocationsForAdwords', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.getKeywordsForAdwords = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getKeywordsForAdwords', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSearchLocations = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchGeoLocations', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getFbSearchLocations = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchFbGeoLocations', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.getAdwordsSearchloctions = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchGeoLocationForAdwords', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.instanceLock = function() {
        return $resource(AppConfig.IO_API_URL + 'InstanceSettings/instanceLocked', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateCodes = function() {
        return $resource(AppConfig.API_URL + 'geovalues/postalcodes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateFbCodes = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchFbGeoZip', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateSnapGeo = function() {
        return $resource(AppConfig.API_URL + 'snapchat/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateSnapCodes = function() {
        return $resource(AppConfig.API_URL + 'snapchat/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSnapSearchLocations = function() {
        return $resource(AppConfig.API_URL + 'snapchat/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSnapLocation = function() {
        return $resource(AppConfig.API_URL + 'snapchat/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };


    factory.getTiktokLocation = function() {
        return $resource(AppConfig.API_URL + 'tiktok/operation', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.validateTiktokGeo = function() {
        return $resource(AppConfig.API_URL + 'tiktok/operation', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.getTritonGeoLocation = function() {
        return $resource(AppConfig.API_URL + 'triton/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTritonSearchlocations = function() {
        return $resource(AppConfig.API_URL + 'triton/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.geoLocationsForTriton = function() {
        return $resource(AppConfig.API_URL + 'triton/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateFbStates = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchFbGeoState', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateFbCities = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchFbGeoCity', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateStates = function() {
        return $resource(AppConfig.API_URL + 'geovalues/states', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.searchLocationsByText = function() {
        return $resource(AppConfig.IO_API_URL + 'googleIntegrations/locationCodes', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.searchLinkedInAdsLocation = function() {
        return $resource(AppConfig.API_URL + 'linkedin/geo', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getStationPodcastForTriton = function() {
        return $resource(AppConfig.API_URL + 'triton/content-targeting', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.validateBulkGoogleLocations = function() {
        return $resource(AppConfig.API_URL + 'adwords/operation', null, {
            'post': {
                method: 'POST'
            }
        })
    };

    factory.getExistingAccountabilityGroupLabels = function() {
        return $resource(AppConfig.API_URL + 'accountability/operation', null, {
            'post': {
                method: 'GET'
            }
        });
    };

    factory.formFieldGroups = function() {
        return $resource(AppConfig.IO_API_URL + 'form/:formFieldGroups', {
            formFieldGroups: '@formFieldGroups'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.formFieldGroup = function() {
        return $resource(AppConfig.IO_API_URL + 'form/formFieldGroup', {
            formFieldGroup: '@formFieldGroup'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.formFields = function() {
        return $resource(AppConfig.IO_API_URL + 'form/:formFields', {
            formFields: '@formFields'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.formFieldDisplayOrder = function() {
        return $resource(AppConfig.IO_API_URL + 'form/formFieldsDisplayOrder', null, {
            'post': {
                method: 'POST'
            }
        });
    }

    factory.lookupContent = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.calculatedFields = function() {
        return $resource(AppConfig.IO_API_URL + 'calc/:requiredFields', {
            requiredFields: '@requiredFields'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.calculatedOrderFields = function() {
        return $resource(AppConfig.IO_API_URL + 'calc/order/:requiredFields', {
            requiredFields: '@requiredFields'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.dataTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'form/dataTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.inputTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'form/inputTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.goalAssociationTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'products/goalFields', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.productRollupTargets = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productRollupTargets', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.clientRollupTargets = function() {
        return $resource(AppConfig.IO_API_URL + 'form/clientRollupTargets', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.orderRollupTargets = function() {
        return $resource(AppConfig.IO_API_URL + 'form/orderRollupTargets', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskRollupTargets = function() {
        return $resource(AppConfig.IO_API_URL + 'form/taskRollupTargets', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.contentTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'form/contentTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.typesForForm = function() {
        return $resource(AppConfig.IO_API_URL + 'form/typesForForm', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.clone = function() {
        return $resource(AppConfig.IO_API_URL + 'form/clone', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.formContents = function() {
        return $resource(AppConfig.IO_API_URL + 'form/:contents', {
            contents: '@contents'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.clientFields = function() {
        return $resource(AppConfig.IO_API_URL + 'form/clientFormFields', {}, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.clientFieldGroups = function() {
        return $resource(AppConfig.IO_API_URL + 'form/clientFormFieldGroups', {}, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.instanceSettings = function() {
        return $resource(AppConfig.IO_API_URL + 'InstanceSettings/:activities', {}, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.instanceSettingArray = function() {
        return $resource(AppConfig.IO_API_URL + 'InstanceSettings/instanceSettingArray', {}, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.PushConnectorClientAccountMapping = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/PushConnectorClientAccountMapping', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAllTaskForms = function() {
        return $resource(AppConfig.IO_API_URL + 'form/getAllTaskForms', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getAllOrderForms = function() {
        return $resource(AppConfig.IO_API_URL + 'form/getAllOrderForms', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getAllClientForms = function() {
        return $resource(AppConfig.IO_API_URL + 'form/getAllClientForms', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getAllFlightForms = function() {
        return $resource(AppConfig.IO_API_URL + 'form/getAllFlightForms', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.orderAndTaskList = function() {
        return $resource(AppConfig.IO_API_URL + 'form/formsByClusterId', null, {
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.orderAndTaskForm = function() {
        return $resource(AppConfig.IO_API_URL + 'form/form', null, {
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.deletePixel = function() {
        return $resource(AppConfig.IO_API_URL + 'pixel/deletePixel', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.editPixel = function() {
        return $resource(AppConfig.IO_API_URL + 'pixel/editPixel', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.getGoalServices = function() {
        return $resource(AppConfig.API_URL + 'goals/services', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getSmartCampaigns = function() {
        return $resource(AppConfig.API_URL + 'smartcampaigns', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getServiceMetrics = function() {
        return $resource(AppConfig.API_URL + 'services/:serviceId/data/cgn', {
            serviceId: '@serviceId'
        }, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getServiceDataViews = function() {
        return $resource(AppConfig.API_URL + 'services/:serviceId/data/data_views', {
            serviceId: '@serviceId'
        }, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.getAudience = function() {
        return $resource(AppConfig.API_URL + 'audience/:id', {
            id: '@id'
        }, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.setContentLinks = function() {
        return $resource(AppConfig.API_URL + 'bridgecorp/contentlinks', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.processFileDelete = function() {
        return $resource(AppConfig.IO_API_URL + 'customModule/processFileDelete', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.getInstagramAccountsForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getInstagramAccountsForClient', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.getFbPagesForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getFbPagesForClient', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.fetchFacebookVideos = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getVideosForFBClient', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };

    factory.orderIdsUsingFormField = function() {
        return $resource(AppConfig.IO_API_URL + 'form/orderIdsUsingFormField', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.flightIdsUsingFormField = function() {
        return $resource(AppConfig.IO_API_URL + 'form/flightIdsUsingFormField', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.recalculateAllOrders = function() {
        return $resource(AppConfig.IO_API_URL + 'form/recalculateAllOrders', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.recalculateAllFlights = function() {
        return $resource(AppConfig.IO_API_URL + 'form/recalculateAllFlights', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.checkExistingAdvertiser = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/checkExistingAdvertiser', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getServiceName = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/getServiceName', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.cloneAllFormLookupContentForClusters = function() {
        return $resource(AppConfig.IO_API_URL + 'form/cloneFormLookupContentForClusters', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.validateSeedListPurple = function() {
        return $resource(AppConfig.API_URL + 'bridgecorp/validateseedlistpurple', null, {
            'post': {
                method: 'POST'
            }
        })
    };
    factory.syncAdvertiserSettings = function() {
        return $resource(AppConfig.API_URL + 'bridgecorp/syncadvertisersettings', null, {
            'post': {
                method: 'POST'
            }
        })
    };
    factory.gamAvailUnits = function() {
        return $resource(AppConfig.API_URL + 'googleadmanager/operation', null, {
            'post': {
                method: 'POST'
            }
        })
    };
    factory.getXandrLocation = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getXandrGeoLocation', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };
    factory.getXandrSearchLocations = function() {
        return $resource(AppConfig.IO_API_URL + 'api/searchXandrLocation', null, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    };
    factory.validateXandrCodes = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getXandrUsPostalCode', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    factory.validateXandrStates = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getXandrUsState', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    factory.validateXandrCities = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getXandrUsCity', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    factory.getSnapchatPixels = function() {
        return $resource(AppConfig.API_URL + 'snapchat/pixels', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;
}])

.factory('FormService', ['FormFactory', '$q', 'Upload', 'AppConfig', '$filter', 'IORestangular', 'ClusterService', '$ioAlert', '$confirm','$http', 'ProductService', 'FieldTransformer', function(FormFactory, $q, Upload, AppConfig, $filter, IORestangular, ClusterService, $ioAlert, $confirm, $http, ProductService, FieldTransformer) {
    var TASK_TYPE_ID = 1;
    var ORDER_TYPE_ID = 2;

    var service = {};
    service.formFieldGroups = null;
    service.formFields = null;
    service.lookupContent = null;
    service.getLocations = [];
    service.getFbLocations = [];
    service.getSnapLocation =[];
    service.getTiktokLocation =[];
    service.getXandrLocations = [];
    service.getSearchLocation = [];
    service.getSearchFbLocation = [];
    service.getSearchSnapLocation = [];
    service.getSearchXandrLocation = [];
    service.instagramAccounts =[];
    service.facebookAccounts =[];
    service.errors = null;
    service.geoLocationsAdwords = [];
    service.getAdwordsSearchLoction =[];
    service.fbUploadedVideos = [];

    service.getGeoSearchloctions = function(clusterId,value) {
        var deferred = $q.defer();
        var params = {
            'value': value,
            'cluster_id': clusterId
        };

        FormFactory.getSearchLocations().get(params).$promise.then(function(data) {
            console.log('data',data.locations);
            service.getSearchLocation = data.locations;
            deferred.resolve(data.locations);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getFbGeoSearchloctions = function(value,culterId) {
        var deferred = $q.defer();
        var params = {
            'value': value,
            'cluster_id' : culterId
        };

        FormFactory.getFbSearchLocations().get(params).$promise.then(function(data) {
            service.getSearchFbLocation = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getSnapGeoSearchlocations = function(value,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value': value,
            'cluster_id' : clusterId
        };
        FormFactory.getSnapSearchLocations().get(params).$promise.then(function(data) {
            service.getSearchSnapLocation = data.data;
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getSnapGeoLocationsById = function(orderId,clusterId,node_id) {
        var deferred = $q.defer();
        var params = {
            'orderId': orderId,
            'cluster_id': clusterId,
            'node_id': node_id
        };
        FormFactory.getSnapLocation().get(params).$promise.then(function(data) {
            service.getSnapLocation = data.data;
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateSnapPostalCodes = function(postalCodes,clusterId,type) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes,
            'cluster_id' : clusterId,
            'type': type
        };
        FormFactory.validateSnapCodes().get(params).$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateSnapGeo = function(postalCodes,clusterId,type) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes,
            'cluster_id' : clusterId,
            'type': type
        };
        FormFactory.validateSnapGeo().get(params).$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTiktokGeoLocations = function(clientId, clusterId, regionId,operation) {
        var deferred = $q.defer();
        var params = {
            'client_id': clientId,
            'cluster_id': clusterId,
            'region_id': regionId || 'NA',
            'operation': operation,
        };
        FormFactory.getTiktokLocation().save(params).$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error getting TikTok geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateTiktokGeo = function(postalCodes,clientId,clusterId,type,operation) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes,
            'client_id': clientId,
            'cluster_id' : clusterId,
            'type': type,
            'operation': operation
        };
        FormFactory.validateTiktokGeo().save(params).$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getAdwordsSearchloctions = function(value) {
        var deferred = $q.defer();
        var params = {
            'value': value
        };

        FormFactory.getAdwordsSearchloctions().get(params).$promise.then(function(data) {
            service.getAdwordsSearchLoction = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getInstanceLockConfig = function() {
        var deferred = $q.defer();

        FormFactory.instanceLock().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting instance lock configuration.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getGeoLocationsById = function(id, clusterId, orderId) {
        var deferred = $q.defer();
        var params = {
            'id': id,
            'clusterId': clusterId,
            'orderId': orderId
        };

        FormFactory.getLocations().get(params).$promise.then(function(data) {
            service.getLocations = data.locations;
            deferred.resolve(data.locations);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getFbGeoLocationsById = function(orderId,clusterId,node_id) {
        var deferred = $q.defer();
        var params = {
            'orderId': orderId,
            'cluster_id': clusterId,
            'node_id': node_id
        };

        FormFactory.getFbLocations().get(params).$promise.then(function(data) {
            service.getFbLocations = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getAdwordsLocationsById = function(Id) {
        var deferred = $q.defer();
        var params = {
            "location_id":Id
        };

        FormFactory.geoLocationsForAdwords().get(params).$promise.then(function(data) {
            service.geoLocationsAdwords = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.geoLocationsForAdwords = function(id) {
        var deferred = $q.defer();
        var params = {
           'location_id':id
        };

        FormFactory.geoLocationsForAdwords().get(params).$promise.then(function(data) {
            service.geoLocationsAdwords = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getKeywordsForAdwords = function(text, pageUrl, clientId) {
        let deferred = $q.defer();
        const params = {
            'text': text,
            'pageUrl': pageUrl,
            'clientId': clientId
        };
        FormFactory.getKeywordsForAdwords().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting keywords.");
            deferred.reject();
        });
        return deferred.promise;
    };
    service.validateGamAvailUnits = function(modelData) {
        var deferred = $q.defer();
        var params =modelData;
        FormFactory.gamAvailUnits().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("");
            deferred.reject();
        });
        return deferred.promise;
    };
    service.validatePostalCodes = function(postalCodes) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes
        };

        FormFactory.validateCodes().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateFbPostalCodes = function(postalCodes,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes,
            'cluster_id' : clusterId
        };

        FormFactory.validateFbCodes().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateFbUsStates = function(states,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': states,
            'cluster_id' : clusterId
        };

        FormFactory.validateFbStates().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateFbUsCities = function(cities,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': cities,
            'cluster_id' : clusterId
        };

        FormFactory.validateFbCities().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateUSStates = function(USStates) {
        var deferred = $q.defer();
        var params = {
            'value[]': USStates
        };

        FormFactory.validateStates().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating US States.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.isValidJsonString = function(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    // Search Locations with typeahead
    service.searchLocations = function(clientId, text) {
        var deferred = $q.defer();
        var params = {
            'clientId': clientId,
            'searchString': text
        };

        FormFactory.searchLocationsByText().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.fetchInstagramAccounts = function(clusterId,clientId,fbPageId) {
        var deferred = $q.defer();
        var params = {
            'clientId': clientId,
            'clusterId': clusterId,
            'fbPageId' : fbPageId
        };

        FormFactory.getInstagramAccountsForClient().get(params).$promise.then(function(data) {
            service.instagramAccounts = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.fetchFacebookAccounts = function(clusterId,clientId) {
        var deferred = $q.defer();
        var params = {
            'clientId': clientId,
            'clusterId': clusterId
        };

        FormFactory.getFbPagesForClient().get(params).$promise.then(function(data) {
            service.facebookAccounts = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.fetchFacebookVideos = function(clusterId,clientId) {
        var deferred = $q.defer();
        var params = {
            'clientId': clientId,
            'clusterId': clusterId
        };

        FormFactory.fetchFacebookVideos().get(params).$promise.then(function(data) {
            service.fbUploadedVideos = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task form field groups
    service.getTaskFormFieldGroups = function(taskId) {
        var deferred = $q.defer();
        var params = {
            'formFieldGroups': 'taskFormFieldGroups',
            'taskId': taskId
        };

        FormFactory.formFieldGroups().get(params).$promise.then(function(data) {
            if (data && data.errors) {
                deferred.reject(data.errors);
            } else if (data && data.formFieldGroups) {
                deferred.resolve(data.formFieldGroups);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting task form field groups for " + taskId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task form fields
    service.getTaskFormFields = function(taskId, clusterId, addLookupContent) {
        var deferred = $q.defer();
        var params = {
            'formFields': 'taskFormFields',
            'taskId': taskId,
            'clusterId': clusterId
        };

        if (addLookupContent) {
            params.lookup = '1';
        }

        FormFactory.formFields().get(params).$promise.then(function(data) {
            service.formFields = data.formFields;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting task form fields for " + taskId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all order form field groups
    service.getOrderFormFieldGroups = function(clusterId) {
        var deferred = $q.defer();
        var params = {
            'formFieldGroups': 'orderFormFieldGroups',
            'clusterId': clusterId,
            'showAll': 'no'
        };

        FormFactory.formFieldGroups().get(params).$promise.then(function(data) {
            if (data && data.errors) {
                deferred.reject(data.errors);
            } else if (data && data.formFieldGroups) {
                deferred.resolve(data.formFieldGroups);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting order form field groups for " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all order form fields
    service.getOrderFormFields = function(clusterId, showAll, addLookupContent, clientId = 0) {
        var deferred = $q.defer();
        var params = {
            'formFields': 'orderFormFields',
            'clusterId': clusterId,
            'clientId': clientId
        };

        if (showAll) {
            params.showAll = 'yes';
        }

        if (addLookupContent) {
            params.lookup = '1';
        }

        FormFactory.formFields().get(params).$promise.then(function(data) {
            service.formFields = data.formFields;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting order form fields for " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get client form fields
    service.getClientFormFields = function(clusterId, showAll, addLookupContent) {
        let deferred = $q.defer();
        let params = {};

        if (clusterId) {
            params.clusterId = clusterId;
        }

        if (showAll) {
            params.showAll = 'yes';
        }

        if (addLookupContent) {
            params.lookup = '1';
        }

        FormFactory.clientFields().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting client form fields for " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get client form field groups
    service.getClientFormFieldGroups = function(clusterId, showAll) {
        let deferred = $q.defer();
        let params = {};

        if (clusterId) {
            params.clusterId = clusterId;
        }

        if (showAll) {
            params.showAll = 'yes';
        }

        FormFactory.clientFieldGroups().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting client form field groups for cluster " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all flight form field groups
    service.getFlightFormFieldGroups = function(formId) {
        var deferred = $q.defer();
        var params = {
            'formFieldGroups': 'formFieldGroups',
            'formId': formId,
            'showAll': 'no'
        };

        FormFactory.formFieldGroups().get(params).$promise.then(function(data) {
            if (data && data.errors) {
                deferred.reject(data.errors);
            } else if (data && data.formFieldGroups) {
                deferred.resolve(data.formFieldGroups);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting flight form field groups for form " + formId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all flight form fields
    service.getFlightFormFields = function(formId, productId, clusterId, showAll, addLookupContent, clientId) {
        var deferred = $q.defer();
        var params = {
            'formFields': 'flightFormFields',
            'formId': formId,
            'productId': productId,
            'clusterId': clusterId,
            'clientId': clientId
        };

        if (showAll) {
            params.showAll = 'yes';
        }

        if (addLookupContent) {
            params.lookup = '1';
        }

        FormFactory.formFields().get(params).$promise.then(function(data) {
            service.formFields = data.formFields;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting flight form fields for formId " + formId + ", productId " + productId + ", and clusterId " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getFlightFormFieldsForProduct = function(productId) {
        var deferred = $q.defer();
        var params = {
            'formFields': 'flightFieldsForProduct',
            'productId': productId
        };

        FormFactory.formFields().get(params).$promise.then(function(data) {
            deferred.resolve(data.formFields);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTaskFormFieldsForClient = function (clientId) {
        return IORestangular.one('/form/taskFormFieldsForClient').get({clientId: clientId})
    }

    service.getTaskFormFieldsForOrder = function (orderId) {
        return IORestangular.one('/form/taskFormFieldsForOrder').get({orderId: orderId})
    }

    service.getTaskFormFieldsForLineItem = function (lineItemId) {
        return IORestangular.one('/form/taskFormFieldsForLineItem').get({lineItemId: lineItemId})
    }

    service.getTaskFormFieldsForFlight = function (flightId) {
        return IORestangular.one('/form/taskFormFieldsForFlight').get({flightId: flightId})
    }

    // Get all lookup content for a lookup type
    service.getLookupContent = function(lookupTypeId, clusterId = 0) {
        var deferred = $q.defer();
        var params = {
            'lookupTypeId': lookupTypeId,
            'clusterId': clusterId
        };

        FormFactory.lookupContent().get(params).$promise.then(function(data) {
            service.lookupContent = data.lookupContents;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting lookup content for type " + lookupTypeId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getLookupContentSearch = function(lookupTypeId, clusterId = 0, searchText='') {
        var deferred = $q.defer();
        var params = {
            'lookupTypeId': lookupTypeId,
            'clusterId': clusterId,
            'isSearch': 'yes',
            'searchText': searchText
        };
        FormFactory.lookupContent().get(params).$promise.then(function(data) {
            if(data.lookupContents){
                deferred.resolve({data: data.lookupContents});
            }else{
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting lookup content for type " + lookupTypeId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getXandrGeoLocationsById = function(orderId,clusterId,node_id) {
        var deferred = $q.defer();
        var params = {
            'orderId': orderId,
            'cluster_id': clusterId,
            'node_id': node_id
        };
        FormFactory.getXandrLocation().get(params).$promise.then(function(data) {
            service.getXandrLocation = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getXandrGeoSearchloctions = function(value,culterId) {
        var deferred = $q.defer();
        var params = {
            'value': value,
            'cluster_id' : culterId
        };
        FormFactory.getXandrSearchLocations().get(params).$promise.then(function(data) {
            service.getSearchXandrLocation = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateXandrPostalCodes = function(postalCodes,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': postalCodes,
            'cluster_id' : clusterId
        };
        FormFactory.validateXandrCodes().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateXandrUsStates = function(states,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': states,
            'cluster_id' : clusterId
        };
        FormFactory.validateXandrStates().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating Us States.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateXandrUsCities = function(cities,clusterId) {
        var deferred = $q.defer();
        var params = {
            'value[]': cities,
            'cluster_id' : clusterId
        };
        FormFactory.validateXandrCities().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating Us Cities.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTritonSearchlocations = function(value) {
        var deferred = $q.defer();
        var params = {
            'value': value
        };

        FormFactory.getTritonSearchlocations().get(params).$promise.then(function(data) {
            service.getAdwordsSearchLoction = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo searched locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.geoLocationsForTriton = function(id) {
        var deferred = $q.defer();
        var params = {
            'location_id':id
        };

        FormFactory.getTritonGeoLocation().get(params).$promise.then(function(data) {
            service.geoLocationsAdwords = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTritonLocationsById = function(Id) {
        var deferred = $q.defer();
        var params = {
            "node_id":Id
        };

        FormFactory.geoLocationsForTriton().get(params).$promise.then(function(data) {
            service.geoLocationsAdwords = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.searchLinkedInAdsLocation = function(clusterId, text) {
        var deferred = $q.defer();
        var params = {
            'cluster_id': clusterId,
            'search_string': text,
        };
        FormFactory.searchLinkedInAdsLocation().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getStationPodcastForTriton = function(Id, type) {
        var deferred = $q.defer();
        var params = {
            "cluster_id":Id,
            "type":type
        };

        FormFactory.getStationPodcastForTriton().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting geo locations.", response);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getSnapchatPixels = function(Id) {
        var deferred = $q.defer();
        var params = {
            "client_id":Id
        };

        FormFactory.getSnapchatPixels().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting snapchat pixels.", response);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.validateBulkGoogleLocations = function(type, values, operation) {
        var deferred = $q.defer();
        var params = {
            'values': values,
            'type': type,
            'operation': operation
        };

        FormFactory.validateBulkGoogleLocations().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error validating postal codes.");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getExistingAccountabilityGroupLabels = function(orderId) {
      var deferred = $q.defer();
      var params = {
        "order_id"  : orderId,
        "operation" : 'get_existing_group_label'
      };

        FormFactory.getExistingAccountabilityGroupLabels().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting group labels.", response);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getSubmitControl = function(controlText, formObj, isOrder, isEditing) {
        var controls = {};
        controls.type = "button";
        controls.title = controlText;
        if (isOrder) {
            if (isEditing) {
                controls.htmlClass = "btn col-sm-4";
            } else {
                controls.htmlClass = "btn col-sm-9";
            }
        } else {
            controls.htmlClass = "btn";
        }
        controls.isSubmitted = false;
        controls.style = 'btn-primary';
        controls.onClick = "submitForm(" + formObj + ")";
        return controls;
    };

    service.getCommentInputSection = function(fromPage, isRequired, cluster_id) {
        var currentClusterId = (cluster_id)?cluster_id:(ClusterService.clusterIds[0]?ClusterService.clusterIds[0]:null);
        var commentSection = {};
        commentSection.type = "section";
        commentSection.containerClass = "container-fluid";
        commentSection.htmlClass = "row-fluid";
        commentSection.sectionTitle = "Add Comment";
        commentSection.items = [];

        if (isRequired) {
            commentSection.sectionTitle = "Add Comment (required)";
        }

        var commentItem = {};
        commentItem.key = "comment";
        commentItem.type = "comments";
        commentItem.notitle = true;
        commentItem.htmlClass = "col-md-12 col-xs-12";
        commentItem.fieldHtmlClass = "col-lg-10 col-md-12 col-xs-12";
        commentItem.labelHtmlClass = "col-sm-12 col-md-12 col-xs-12 col-lg-4";
        commentItem.clientId = currentClusterId;

        commentSection.items.push(commentItem);
        return commentSection;
    };

    service.getCreateAdvertiserWarning = function(clientId = null, serviceId = null, fromPage = null) {
        var deferred = $q.defer();
        let instance_settings;
        let message;
        let proceed;
        let link = AppConfig.TA_URL + "#/service/manage";
        let redirection_message;

        FormFactory.getServiceName().get({
            'serviceId' : serviceId
        }).$promise.then(function (response) {
            if(response.service_name) {
                switch (response.service_name) {
                    case "Google Adwords" :
                        instance_settings = [
                            "adwords_enable_advertiser_creation",
                            "adwords_include_new_advertiser_warning",
                        ];
                        message = "This will create a new Account in Google Ads and automatically map it in TapAnaltyics. Proceed?";
                        redirection_message = "If the Account already exists and just needs to be mapped, go to ";
                        break;
                    case "DFP":
                        instance_settings = [
                            "enable_advertiser_creation",
                            "include_new_advertiser_warning",
                            "enable_push_flights",
                            "push_line_item_to_gam_in_ready_status",
                        ];
                        message = "This will create a new Advertiser in GAM and automatically map it in TapAnaltyics. Proceed?";
                        redirection_message = "If the Advertiser already exists and just needs to be mapped, go to ";
                        break;
                    default:
                        deferred.resolve(true);
                        return deferred.promise
                }

                FormFactory.instanceSettingArray().get({
                    'instanceSettingTypeArray[]': instance_settings
                }).$promise.then(function(data) {
                    if(data.instance_settings.enable_push_flights) {
                        if ((data.instance_settings.enable_push_flights === "0" && fromPage === "lineItem") ||
                            (data.instance_settings.enable_push_flights === "1" && fromPage === "flight")) {
                            if (data.instance_settings.enable_advertiser_creation === "1" && data.instance_settings.include_new_advertiser_warning === "1") {
                                proceed = true;
                            }
                        }
                    } else if (data.instance_settings.adwords_enable_advertiser_creation === "1" && data.instance_settings.adwords_include_new_advertiser_warning === "1") {
                        proceed = true;
                    }else if (data.instance_settings.push_line_item_to_gam_in_ready_status === "1") {
                        proceed = true;
                    }

                    if(proceed === true) {
                        FormFactory.checkExistingAdvertiser().get({
                            clientId: clientId,
                            serviceId: serviceId
                        }).$promise.then(function (response) {
                            if (response.message) {
                                $confirm.open({
                                    size: 'sm',
                                    text: message,
                                    link: link,
                                    redirect_text: "Manage Data Source.",
                                    redirection_message: redirection_message
                                }).then(function () {
                                    deferred.resolve(true);
                                }, function () {
                                    deferred.resolve(false);
                                });
                            } else {
                                deferred.resolve(true);
                            }
                        }, function (error) {
                            deferred.reject(error);
                        });
                    } else {
                        deferred.resolve(true);
                    }
                }, function(response) {
                    deferred.reject(response);
                });
            } else {
                deferred.resolve(true);
            }
        }, function(response) {
            deferred.resolve(true);
        });
        return deferred.promise;
    };

    service.addCommentSchema = function(schema) {
        var commentProperty = {};
        commentProperty.type = "object";
        schema.properties.comment = commentProperty;
    };

    service.buildDynamicFormSchema = function(schema, formFieldMap, formFields, isEditing, preModelData, creatives, realCreativeFilenames, enforceRequiredCreatives = true) {
        schema.type = "object";
        schema.properties = {};
        schema.required = [];
        if (!enforceRequiredCreatives && realCreativeFilenames != null) {
            // This does 2 things: First, it appends the realCreativeFilenames returned from makeCreativeFieldsNotRequiredIfCreativesAlreadyExist
            // to the passed in realCreativeFilenames, and second, as a side effect, it updates the "creative" formFields
            // to make them non-required if there are already creatives for the entity (non-file creatives).
            // We'll need those filenames later in case the creatives are removed from the edited form, so that validation
            // can require a creative if all of them were deleted during edit...
            realCreativeFilenames.push.apply(realCreativeFilenames, makeCreativeFieldsNotRequiredIfCreativesAlreadyExistAndReturnRealCreativeFilenames(formFields, preModelData, creatives));
        }
        for (let i = 0; i < formFields.length; i++) {
            let field = formFields[i];
            formFieldMap[field.id] = field;
            schema.properties[field.field_name] = getFieldProperties(field, isEditing, preModelData);
            if (field.required == '1') {
                schema.required.push(field.field_name);
            }
            if(field.input_type === 'select' && field.default_value && schema.properties[field.field_name].enum){
                var defaultValuePos = schema.properties[field.field_name].enum.indexOf(field.default_value);
                if(defaultValuePos<0){
                    field.default_value = "";
                }
            }
        }
    };

    service.updateForm = function(dataSource, editArray) {
        let entityData = angular.copy(dataSource);
        _.each(editArray, function(edit) {
            const field_name = edit.prop;
            switch (edit.type) {
                case 'boolean':
                    if (entityData.hasOwnProperty(field_name)) {
                        entityData[field_name] = entityData[field_name] == 1;
                    }
                    break;
                case 'array':
                    let selectArr = [];
                    if (entityData.hasOwnProperty(field_name)) {
                        const arrlen = entityData[field_name].length;
                        if (arrlen == 2 && typeof entityData[field_name][1] == 'string') {
                            selectArr.push(entityData[field_name][1]);
                        } else {
                            for (let k = 0; k < arrlen; k++) {
                                if (entityData[field_name][k] && entityData[field_name][k].length == 1) {
                                    selectArr.push(String(entityData[field_name][k][0]).replace("CUST_", ""));
                                } else if (entityData[field_name][k]) {
                                    selectArr.push(entityData[field_name][k][1]);
                                }
                            }
                        }
                        entityData[field_name] = selectArr;
                    } else {
                        // if entity data does not have the attribute for multi-select
                        // field, we need to set its value to empty array [] instead of
                        // undefined value as default
                        entityData[field_name] = selectArr;
                    }
                    break;
                case 'string':
                    if (entityData.hasOwnProperty(field_name)) {
                        if (typeof entityData[field_name] == 'object') {
                            entityData[field_name] = entityData[field_name][1];
                        }
                    }
                    break;
            }
        });
        return entityData;
    };

    service.buildDynamicForm = function(model, form, formParentChildInfo, schema, formFieldMap,
                                        formFieldGroups, formFields, isEditing, clientId, productObj,
                                        order, userRole, fromPage, lineItem = null) {
        let sections = {};
        // Create a form section per field group
        formFieldGroups?.forEach(formFieldGroup => {
            if (formFieldGroup.group_name.includes('Buy') && !isEditing) {
                return;
            }
            const sectionType = formFieldGroup.hideForCondition?.includes(userRole.role_id)
            && formFieldGroup.hideForConditionType == 'Role Type' ? 'hidden' : 'section';

            let newSection = {};
            newSection.type = sectionType;
            newSection.containerClass = "container-fluid";
            newSection.htmlClass = "row-fluid";
            newSection.items = [];
            newSection.showSectionTitleCondition = true;
            newSection.hideForConditionValue = formFieldGroup.hideForConditionValue;
            newSection.hideForConditionType = formFieldGroup.hideForConditionType;

            if (!_.isEmpty(formFieldGroup) && formFieldGroup.group_name) {
                newSection.sectionTitle = formFieldGroup.group_name;
            }
            sections[formFieldGroup.id] = newSection;
            form.push(newSection);
        });
        if (fromPage == "task") {
            for (let i = 0; i < formFields.length; i++) {
                let field = formFields[i];
                if (typeof model[field.field_name] !== 'undefined') {
                    isEditing = true;
                    break;
                }
            }
        }
        // Process each field and assign to a section
        let endDate_dateRules = undefined;
        for (let i = 0; i < formFields.length; i++) {
            let field = formFields[i];
            if (!sections[field.group_id]) {
                continue; // skip the fields in the inactive group
            }
            if (field.field_name == "client_id") {
                service.formClients = field.lookup_content;
            }
            let item = getFormFieldProperties(field, model, isEditing, clientId, productObj, order, fromPage, lineItem);
            item.key = field.field_name;
            if (field.data_type == "date" && field.field_name == 'end_date') {
                endDate_dateRules = item.dateRules;
            }
            item.conditionInfo = {};
            // Process conditional field
            if (!_.isEmpty(field) && field.parent_id) {
                let parentField = formFieldMap[field.parent_id];

                if (!_.isEmpty(parentField) && parentField.lookup_content && field.parent_trigger_id) {
                    let conditionalContentValues = [];
                    _.each(parentField.lookup_content, function(contentObj){
                        if(field.parent_trigger_id.includes(contentObj.id)){
                            conditionalContentValues.push(contentObj.lookup_value);
                        }
                    });

                    if (conditionalContentValues && conditionalContentValues.length > 0) {
                        item.condition = buildFieldFamilyCondition(field, formFieldMap);
                        item.conditionInfo.parent_name = parentField.field_name;
                        item.conditionInfo.lookup_value = conditionalContentValues;
                        item.conditionInfo.input_type = parentField.input_type;
                        field.condition = item.condition;
                        field.conditionValue = conditionalContentValues;
                        field.parentField = parentField;
                    } else {
                        // We could not skip this case if the expected form lookup contents
                        // are not set. The field should be hidden.
                        item.condition = '1 == 0';
                        item.conditionInfo.parent_name = parentField.field_name;
                        item.conditionInfo.lookup_value = ['parent form lookup contents missing'];
                        item.conditionInfo.input_type = parentField.input_type;
                        field.condition = item.condition;
                        field.conditionValue = ['parent form lookup contents missing'];
                        field.parentField = parentField;
                    }
                } else if (!_.isEmpty(parentField) && parentField.input_type == "checkbox") {
                    // if parent trigger id is not present defaulting the child value to true
                    item.condition = buildFieldFamilyCondition(field, formFieldMap);
                    item.conditionInfo.parent_name = parentField.field_name;
                    item.conditionInfo.input_type = "checkbox";
                    field.condition = item.condition;
                    field.conditionValue = field.parent_trigger_id;
                    field.parentField = parentField;
                    //item.destroyStrategy = "null";
                }
            }

            const hideConditionValue = fieldFamilyOrderTypeConditionValue(field, formFieldMap, sections);
            if (hideConditionValue) {
                const order_type_show_condition = 'model["order_type_id"] != "' + hideConditionValue + '"';
                const mixed_condition = item.condition + ' && ' + order_type_show_condition;
                item.condition = item.condition ? mixed_condition : order_type_show_condition;
            }

            // Build map of lookup type parent-child association, so that we can prune the list of available child
            // values when a parent value changes.  Note that a parent could have multiple children, so this is
            // supported by associating an array of children for a given parent, inside the formParentChildInfo object.
            if (field.parent_lookup_type_id) {
                let parentFieldForLookupType = formFields.find(formField => formField['lookup_type_id'] == field.parent_lookup_type_id);
                if (parentFieldForLookupType) {
                    let childEntry = {};
                    let options = [];
                    childEntry.childFieldName = field.field_name;
                    childEntry.input_type = field.input_type;
                    let group = formFieldGroups.find(ffGroup => ffGroup['id'] == field.group_id);
                    if (group) {
                        childEntry.childGroupName = group.group_name;
                    }
                    if (!(parentFieldForLookupType.field_name in formParentChildInfo)) {
                        formParentChildInfo[parentFieldForLookupType.field_name] = [];
                    }
                    childEntry.childLookupContent = field.lookup_content;
                    childEntry.parentLookupContent = parentFieldForLookupType.lookup_content;
                    if (schema.properties[childEntry.childFieldName].enum) {
                        schema.properties[childEntry.childFieldName].enum =
                            pruneChildValuesGivenParentValue(model[parentFieldForLookupType.field_name], childEntry.parentLookupContent, childEntry.childLookupContent, false);
                        options = schema.properties[childEntry.childFieldName].enum;
                    } else if (schema.properties[childEntry.childFieldName].items) {
                        schema.properties[childEntry.childFieldName].items =
                            pruneChildValuesGivenParentValue(model[parentFieldForLookupType.field_name], childEntry.parentLookupContent, childEntry.childLookupContent, true);
                        options = schema.properties[childEntry.childFieldName].items;
                    }

                    //automatically select the value if there is only one.
                    switch (childEntry.input_type) {
                        case 'select':
                            options.length == 2 ? model[childEntry.childFieldName] = options[1] : '';
                            break;
                        case 'multiselect':
                            options.length == 1 ? model[childEntry.childFieldName] = [options[0]['value']] : '';
                            break;
                        case 'multiselect-custom':
                            options.length == 1 ? model[childEntry.childFieldName] = options : '';
                            break;
                    }
                    //console.log('Adding child field ' + childEntry.childFieldName + ' to parent ' + parentFieldForLookupType.field_name);
                    formParentChildInfo[parentFieldForLookupType.field_name].push(childEntry);
                }
            }

            if (sections[field.group_id]) {

                // This callback will be invoked whenever a value changes.  If the field has children (in other words,
                // dependant fields), their list of possible values will be modified accordingly.  For example, if
                // parent has possible values 'bw' and 'color', and the child has 'black','white','red','blue', then
                // it could be configured such that if parent's selected value is 'bw', then the child possible values
                // will be pruned to 'black','white' only, and if parent is 'color', child field will only display
                // 'red','blue' as possible values in the selection.

                item.onChange = function (modelValue, modifiedForm) {
                    let modifiedFieldName = modifiedForm.field_name;

                    // Remove any leftover values from the previous parent value
                    let formValues = Object.values(formParentChildInfo);
                    let allChildren = [];
                    formValues.forEach(function (item, index) { allChildren = allChildren.concat(item);});
                    let matchingChildren = allChildren.filter(child => child['childFieldName'] == modifiedFieldName);
                    matchingChildren.forEach(function (item, index) {
                        //console.log('Modified child: ' + item.childFieldName);
                        const modelValues = model[item.childFieldName];
                        if (Array.isArray(modelValues)) {
                            let prunedModelValues = [];
                            for (let mvIdx = 0; mvIdx < modelValues.length; mvIdx++) {
                                if (modifiedForm.schema.items.some(item => item['value'] == modelValues[mvIdx])) {
                                    prunedModelValues.push(modelValues[mvIdx]);
                                }
                            }
                            if (modelValues.length != prunedModelValues.length) {
                                // Avoid setting the model if the list really wasn't pruned.
                                model[item.childFieldName] = prunedModelValues;
                            }
                        }
                    });

                    if (!(modifiedFieldName in formParentChildInfo)) {
                        return;
                    }

                    for (let childIndex = 0; childIndex < formParentChildInfo[modifiedFieldName].length; childIndex++) {
                        let childInfo = formParentChildInfo[modifiedFieldName][childIndex];
                        let currentForm = form.find(oneForm => oneForm['sectionTitle'] == childInfo.childGroupName);
                        if (!currentForm) {
                            console.log('Error: cannot find form for group ' + childInfo.childGroupName);
                            continue;
                        }
                        let item = currentForm.items.find(oneItem => oneItem['field_name'] == childInfo.childFieldName);
                        if (!item) {
                            console.log('Error: cannot find item ' + childInfo.childFieldName + ' in group ' + childInfo.childGroupName);
                            continue;
                        }
                        //console.log('Child found to be updated: ' + childInfo.childFieldName);
                        let options = [];
                        if (schema.properties[childInfo.childFieldName].enum) {
                            let prunedEnum = pruneChildValuesGivenParentValue(modelValue, childInfo.parentLookupContent, childInfo.childLookupContent, false);
                            schema.properties[childInfo.childFieldName].enum = prunedEnum;
                            if (item.schema) {
                                item.schema.enum = prunedEnum;
                            }
                            if (model[childInfo.childFieldName]) {
                                // Only clear the child field value if its value is not in the new pruned list of values.
                                if (!prunedEnum.includes(model[childInfo.childFieldName])) {
                                    model[childInfo.childFieldName] = ''; // clear model values for single select
                                }
                            }
                            item.titleMap = [];
                            delete item.default_value;
                            for (let prunedIndex = 0; prunedIndex < prunedEnum.length; prunedIndex++) {
                                let prunedValue = prunedEnum[prunedIndex];
                                let newVal = {};
                                newVal.name = prunedValue;
                                newVal.value = prunedValue;
                                item.titleMap.push(newVal);
                            }
                            options = prunedEnum;
                        } else if (schema.properties[childInfo.childFieldName].items) {
                            let prunedItems = pruneChildValuesGivenParentValue(modelValue, childInfo.parentLookupContent, childInfo.childLookupContent, true);
                            schema.properties[childInfo.childFieldName].items = prunedItems;
                            item.schema.items = prunedItems;
                            if (item.hasOwnProperty('select_models')) {
                                const prunedValues = prunedItems.map((x) => x.value);
                                let prunedSelectModels = [];
                                item.select_models.forEach((currentSm) => {
                                    if (prunedValues.includes(currentSm.value)) {
                                        prunedSelectModels.push(currentSm);
                                    }
                                });
                                item.select_models = prunedSelectModels;
                                let prunedModelEntries = [];
                                model[childInfo.childFieldName].forEach((currentModelEntry) => {
                                    if (prunedValues.includes(currentModelEntry)) {
                                        prunedModelEntries.push(currentModelEntry);
                                    }
                                });
                                model[childInfo.childFieldName] = prunedModelEntries;
                            }
                            delete item.default_value;
                            // No titleMap in this case.  But clear model's array.
                            options = prunedItems;
                        }

                        // automatically select the value if there is only one.
                        // the field in the hidden group does not have schema,
                        // and it needs to be updated as well
                        switch (childInfo.input_type) {
                            case 'select':
                                options.length == 2 ? model[childInfo.childFieldName] = options[1] : '';
                                break;
                            case 'multiselect':
                                if (options.length == 1) {
                                    model[childInfo.childFieldName] = ([options[0]['value']]); // reset model value
                                    item.select_models = options; // reset view value
                                }
                                break;
                            case 'multiselect-custom':
                                if (options.length == 1) {
                                    model[childInfo.childFieldName] = options; // reset model value
                                    item.select_models = options; // reset view value
                                }
                                break;
                        }
                    }
                };

                sections[field.group_id].items.push(item);
            }
        }

        _.each(sections, function(sectionObj){
            _.each(sectionObj.items, function(item){
                if (item.field_name == 'start_date') {
                    item.endDate_dateRules = endDate_dateRules;
                }
            });
        });

        _.each(sections, function(sectionObj){
            const havingConditionItems = _.filter(sectionObj.items, function(item) {
                return (item.condition && item.condition.length > 0);
            });
            if (havingConditionItems.length > 0 && havingConditionItems.length === sectionObj.items.length) {
                const conditionList = havingConditionItems.map(function(item){
                    return "(" + item.condition + ")";
                });
                sectionObj.showSectionTitleCondition = "(" + conditionList.join(" || ") + ")";
            } else if (sectionObj.items.length === 0) {
                sectionObj.showSectionTitleCondition = '1 == 0'; // we cannot assign false here
            }
        });
    };

    const buildFieldFamilyCondition = function(field, formFieldMap) {
        let condition = '';
        let parentFieldCondition = '';
        if (!_.isEmpty(field) && field.parent_id) {
            let parentField = formFieldMap[field.parent_id];

            parentFieldCondition = buildFieldFamilyCondition(parentField, formFieldMap);

            if (!_.isEmpty(parentField) && parentField.lookup_content && field.parent_trigger_id) {
                let conditionalContentValues = [];
                _.each(parentField.lookup_content, function(contentObj){
                    if(field.parent_trigger_id.includes(contentObj.id)){
                        conditionalContentValues.push(contentObj.lookup_value);
                    }
                });

                if (conditionalContentValues.length > 0) {
                    if (['multiselect', 'multiselect-custom'].includes(parentField.input_type)) {
                        let conditionalArray = [];
                        _.each(conditionalContentValues, function (contentValue) {
                            // Replace all single backward slashes with double to match what we do
                            // for model value
                            contentValue = contentValue.replace(/\\/g, '\\\\');
                            conditionalArray.push('model["' + parentField.field_name + '"].includes("' + contentValue + '")');
                        });

                        condition = "( " + conditionalArray.join(" || ") + " )";
                    } else {
                        //item.destroyStrategy = "null";
                        let conditionalArray = [];
                        _.each(conditionalContentValues, function (contentValue) {
                            // Replace all single backward slashes with double to match what we do
                            // for model value
                            contentValue = contentValue.replace(/\\/g, '\\\\');
                            conditionalArray.push('model["' + parentField.field_name + '"] == "' + contentValue + '"');
                        });

                        condition = "( " + conditionalArray.join(" || ") + " )";
                    }
                } else {
                    condition = 'false';
                }
            } else if (!_.isEmpty(parentField) && parentField.input_type == "checkbox") {
                // if parent trigger id is not present defaulting the child value to true
                if (field.parent_trigger_id) {
                    condition = 'model["' + parentField.field_name + '"] == ' + field.parent_trigger_id[0];
                } else {
                    condition = 'model["' + parentField.field_name + '"] == 1';
                }
            }
        }
        condition = parentFieldCondition ? ( parentFieldCondition + " && " + condition ) : condition;
        
        return condition;
    };

    const fieldFamilyOrderTypeConditionValue = function (field, formFieldMap, sections) {
        let hideConditionValue = '';
        let ParentHideConditionValue = '';
        if (!_.isEmpty(field) && field.parent_id) {
            let parentField = formFieldMap[field.parent_id];
            if (parentField) {
                ParentHideConditionValue = fieldFamilyOrderTypeConditionValue(parentField, formFieldMap, sections);
            }
        }

        const section = sections[field.group_id];
        if (section?.hideForConditionValue && section?.hideForConditionType == 'Order Type') {
            hideConditionValue = section.hideForConditionValue
        }

        return hideConditionValue ? hideConditionValue : ParentHideConditionValue;
    };

    service.hiddenByParent = function(field, fieldList, entity) {
        if (field.parent_id) {
            let parent_field = fieldList.find(fieldElement => fieldElement.id == field.parent_id);
            if (parent_field && entity.hasOwnProperty(parent_field.field_name)) {
                let parentValues = entity[parent_field.field_name];
                if (Array.isArray(parentValues)) {
                    if (Array.isArray(parentValues[0])) {
                        for (let i in parentValues) {
                            if (field.parent_trigger_id.indexOf(parentValues[i][0]) != -1) { // multi select
                                return false;
                            }
                        }
                    } else if (field.parent_trigger_id.indexOf(parentValues[0]) != -1) { // single select
                        return false;
                    }
                } else if (field.parent_trigger_id.indexOf(parentValues) != -1) { // checkbox
                    return false;
                }
                return true;
            } else {
                return true;
            }
        }
        return false;
    }

    const pruneChildValuesGivenParentValue = function(parentValue, parentLookupContent, childLookupContent, multiselect) {
        let returnEnum = [];
        // For single select, add empty value.
        if (!multiselect) {
            returnEnum.push('');
        }
        for (let i = 0; i < childLookupContent.length; i++) {
            let childItem = childLookupContent[i];
            if (childItem.lookup_value == '') {
                // Don't add it twice
                continue;
            }
            if (!parentValue || parentValue == '' || parentValue == ['']) {
                // Don't prune if there's no parent value
                returnEnum.push(childItem.lookup_value);
                continue;
            }
            // If we get here, there is a parentValue, and we prune any child value who's parent value is not
            // identical to parentValue.
            let parentLookupContentItem = parentLookupContent.find(lookup => lookup['id'] == childItem.parent_content_key_source_id);
            if (parentLookupContentItem) {
                if (parentLookupContentItem.lookup_value == parentValue ||
                    (Array.isArray(parentValue) &&
                        (parentValue.some(lookup => lookup == parentLookupContentItem.lookup_value) ||
                            parentValue.some(lookup => lookup['label'] == parentLookupContentItem.lookup_value)))) {
                    // Child's parent is the selected parent value, so add the child value to the list.
                    returnEnum.push(childItem.lookup_value);
                }
            }
        }
        if (multiselect) {
            let multiItems = [];
            for (let x = 0; x < returnEnum.length; x++) {
                let itemValue = returnEnum[x];
                var item = {};
                item.value = itemValue;
                item.label = itemValue;
                multiItems.push(item);
            }
            return multiItems;
        }
        return returnEnum;
    };

    service.evaluateRule = function(productField, value, rule) {
        var errorMessage = null;
        var result = eval(value + rule.operation_value + rule.rule_value);

        if (!result) {
            errorMessage = productField.display_name + ' must be ' + rule.operation_value + ' than ' + rule.rule_value;
        }

        return errorMessage;
    };

    service.validateDataType = function(productField, dataValue) {
        var errorString = null;

        switch (productField.data_type) {
            case "decimal":
            case "integer":
                if (isNaN(dataValue.replace(/,/g, ''))) {
                    errorString = productField.display_name + " must be a valid number.";
                }
                break;
            case "currency":
                var currencyVal = dataValue.substring(1);
                if (isNaN(currencyVal)) {
                    errorString = productField.display_name + " must be a valid currency value.";
                }
                break;
        }

        return errorString;
    };

    var getParameterName = function(field) {
        var parameterName = null;

        switch (field.field_name) {
            case 'client_id':
                parameterName = 'clientId';
                break;
            case 'order_type_id':
                parameterName = 'orderTypeId';
                break;
            case 'salesperson_id':
                parameterName = 'salespersonId';
                break;
            case 'status_id':
                parameterName = 'statusId';
                break;
            default:
                parameterName = 'ff' + field.id;
        }
        return parameterName;
    };

    service.validateTextArea = function(fields, model) {
        let isValid = true
        _.each(fields, function(field) {
            isValid = isValid && checkForTextArea(model, field)
        })

        return {
            model: model,
            isValid: isValid
        }
    }

    function checkForTextArea(model, field) {
        if (field.input_type != 'textarea') {
            return true
        }

        const value = model[field.field_name];
        if (value && value.indexOf('<p>') < 0) {
            return true;
        }
        let isValid = true
        let innerText = angular.element(value).text()
        let regex = /^\w{1}$/

        if (innerText.length == 1 && !regex.test(innerText)) {
            if (field.required == 1) {
                isValid = false;
            }
            delete model[field.field_name]
        }

        return isValid
    }

    function processDayPartings(dayPartsObj){
        let days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        _.each(dayPartsObj.dayParts, function(dayPart, index) {
            if(dayPart.dayName === "All days") {
                _.each(days, function(day) {
                    var dayNameObj = {};
                    dayNameObj.dayName = day;
                    dayNameObj.slots = dayPart.slots;
                    dayPartsObj.dayParts.push(dayNameObj);
                })
                dayPartsObj.dayParts.splice(index, 1);
            } else if(dayPart.dayName === "Monday - Friday") {
                _.each(days, function(day, index) {
                    if(index >= 0 && index <= 4) {
                        var dayNameObj = {};
                        dayNameObj.dayName = day;
                        dayNameObj.slots = dayPart.slots;
                        dayPartsObj.dayParts.push(dayNameObj);
                    }
                })
            } else if(dayPart.dayName === "Saturday - Sunday") {
                _.each(days, function(day) {
                    if(day === "Saturday" || day === "Sunday") {
                        var dayNameObj = {};
                        dayNameObj.dayName = day;
                        dayNameObj.slots = dayPart.slots;
                        dayPartsObj.dayParts.push(dayNameObj);
                    }
                })
            }

        })
    }

    /**
     * We are modifying some fields' required flag when building the dynamic form, for creative fields, if there
     * are already creative files loaded with the entity we are editing.  This is so we don't have to provide new
     * creatives each time we are editing a form.  We identify such required creatives here so we can later restore
     * the required flag for those fields.
     *
     * @param fields
     * @returns {*[]}
     */
    service.getRequiredCreativeFieldIds = function(fields) {
        let requiredFieldIds = [];
        _.each(fields, function(field) {
            if (field.input_type == 'creative' && field.required == '1') {
                requiredFieldIds.push(field.id);
            }
        });
        return requiredFieldIds;
    }

    service.restoreRequiredCreativeFieldIds = function(fields, requiredFieldIds) {
        _.each(fields, function(field) {
            if (requiredFieldIds.includes(field.id)) {
                field.required = '1';            }
        });
    }

    /**
     * This determines whether a form has required creatives that are not hidden (by some parent field).
     *
     * @param fields
     * @param model
     * @returns {boolean}
     */
    service.formHasRequiredCreativeFields = function(fields, model) {
        let found = false;
        _.each(fields, function(field) {
            let hidden = !getFamilyNestedCondition(field, model);
            if (!hidden && field.input_type == 'creative' && field.required == '1') {
                found = true;
            }
        })
        return found;
    }

    service.validateCreativesPresent = function(fields, model, realCreativeFilenames) {
        if (realCreativeFilenames.length > 0) {
            // We didn't delete all creatives, so we're okay.
            return true;
        }
        // All creatives were deleted, but see if new ones were added/selected.
        let found = false;
        _.each(fields, function(field) {
            if (field.input_type == 'creative' && model[field.field_name]) {
                found = true;
            }
        });
        return found;
    }

    service.validateDayPartingWidget = function(fields, model) {
        let field_name_obj = _.find(fields, {input_type: "day-parting"});
        if(field_name_obj) {
            var dp_field_name = field_name_obj.field_name;
            // processDayPartings(model[dp_field_name])
        }
        let slotsValidation = true;
        _.each(fields, function(field) {
            if (field.input_type == 'day-parting' && !_.isEmpty(model[dp_field_name])) {
                _.each(model[dp_field_name].dayParts, function(dayPartObj,d_index) {
                    _.each(dayPartObj.slots, function(slotObj, s_index) {
                        if(slotObj.start === slotObj.end) {
                            if(slotObj.start === "00:00" && slotObj.end === "00:00") {
                                slotsValidation = true;
                            } else {
                                slotsValidation = false;
                            }
                        } else if(slotObj.start > slotObj.end) {
                            slotsValidation = false;
                        } else {
                            _.each(dayPartObj.slots, function(nextSlotObj, n_index) {
                                if(s_index != n_index) {
                                    if(slotObj.start > nextSlotObj.start && slotObj.start < nextSlotObj.end) {
                                        slotsValidation = false;
                                    }
                                    if(slotObj.end > nextSlotObj.start && slotObj.end < nextSlotObj.end) {
                                        slotsValidation = false;
                                    }
                                }
                            });
                        }
                    });
                });
            }
        });
        if(slotsValidation == false){
            return false;
        } else {
            return true;
        }
    }

    service.validateAdsBiddingWidget = function (fields, model) {
        let field_name_obj = _.find(fields, { input_type: "google-ads-bidding" });
        if (field_name_obj) {
            var bidding_field_name = field_name_obj.field_name;
        }
        if (model[bidding_field_name] && model[bidding_field_name].bidding_method == "Target_ROAS") {
            if (ProductService.trackedConversionCount < 15) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    service.validatePinterestFrequencyCap = function(fields, model) {
        let isValidFrequencyCap = true
        let field_name_obj = _.find(fields, {input_type: "pinterestAds-frequency-controls"});
        let pinterest_frequency_field_name;
        if (field_name_obj) {
            pinterest_frequency_field_name = field_name_obj.field_name;
        }
        if (model[pinterest_frequency_field_name]) {
            if (model[pinterest_frequency_field_name][0].impressions < -1) {
                isValidFrequencyCap = false
                $ioAlert.show('Error!', 'Frequency cap too low', 'error')
            } else if (model[pinterest_frequency_field_name][0].impressions > 20) {
                isValidFrequencyCap = false
                $ioAlert.show('Error!', 'Frequency cap too high', 'error')
            } else {
                isValidFrequencyCap = true
            }
        }
        return isValidFrequencyCap
    }

    service.validateAdScheduleWidget = function(fields, model) {
        let field_name_obj = _.find(fields, {input_type: "ad-schedule"});
        if(field_name_obj) {
            var dp_field_name = field_name_obj.field_name;
        }
        let slotsValidation = true;
        _.each(fields, function(field) {
            if (field.input_type == 'ad-schedule' && !_.isEmpty(model[dp_field_name])) {
                _.each(model[dp_field_name].backend, function(slotObj,d_index){
                    if(slotObj.dayOfWeek == "" || slotObj.startTime == "" || slotObj.endTime == ""){
                        model[dp_field_name].splice(d_index,1);
                    }
                    else{
                        if(slotObj.startTime === slotObj.endTime) {
                            if(slotObj.startTime === "00:00" && slotObj.endTime === "00:00") {
                                slotsValidation = true;
                            } else {
                                slotsValidation = false;
                                $ioAlert.show('Error!', 'Start time and End time cannot be same', 'error');
                            }
                        }else if(slotObj.startTime > slotObj.endTime) {
                            slotsValidation = false;
                            $ioAlert.show('Error!', 'Start Time should come before End Time', 'error');
                         }
                        else{
                            var filterData = _.filter(model[dp_field_name], {dayOfWeek: slotObj.dayOfWeek})
                            if(filterData || filterData.length > 0){
                                _.each(filterData, function(item){
                                    if(slotObj.startTime > item.startTime && slotObj.startTime < item.endTime){
                                        slotsValidation = false;
                                        $ioAlert.show('Error!', 'Start Time '+slotObj.startTime+' is overlap with other slots', 'error');
                                    }
                                    if(slotObj.endTime > item.startTime && slotObj.endTime < item.endTime){
                                        slotsValidation = false;
                                        $ioAlert.show('Error!', 'End Time '+slotObj.endTime+' is overlap with other slots', 'error');
                                    }
                            });
                            }
                        }
                    }
                });
            }
        });
        if(slotsValidation == false){
            return false;
        } else {
            return true;
        }
    }

    service.validateCustomWidgets = function(fields, model) {
        let isValid = true;
        let validWidgets = [];
        _.each(fields, function(field) {
            isValid = isValid && checkForTextArea(model, field)
            if (field.input_type == 'location-picker' ||
                field.input_type == 'location-picker-fb' ||
                field.input_type == 'DFP' ||
                field.input_type == 'location-targeting' ||
                field.input_type == 'ad-group' ||
                field.input_type == 'facebook-create-ads' ||
                field.input_type == 'dfp-frequency' ||
                field.input_type == 'google-ads-aud-targeting' ||
                field.input_type == 'devices' ||
                field.input_type == 'device-capability' ||
                field.input_type == 'dfp_ad_units' ||
                field.input_type == 'geo-location' ||
                field.input_type == 'day-parting' ||
                field.input_type == 'multiselect-custom' ||
                field.input_type == 'multiple-mappings' ||
                field.input_type == 'connection' ||
                field.input_type == 'geo-location' ||
                field.input_type == 'day-parting' ||
                field.input_type == 'ad-schedule' ||
                field.input_type == 'shopping_adgroup_singleproduct' ||
                field.input_type == 'shopping_adgroup_multiproduct' ||
                field.input_type == 'mobile-app' ||
                field.input_type == 'facebook-ads-location' ||
                field.input_type == "snapchat-ads-location" ||
                field.input_type == "facebookAds-frequency-controls" ||
                field.input_type == "snapChat-frequency-controls" ||
                field.input_type == "xandrInvest-frequency-controls" ||
                field.input_type == "pinterestAds-frequency-controls" ||
                field.input_type == "custom-macro-mapping" ||
                field.input_type == "custom-macro-mapping-2" ||
                field.input_type == "seed-list-macros" ||
                field.input_type == "pos-matchback-details" ||
                field.input_type == "age-targeting" ||
                field.input_type == "snap-chat-age-targeting" ||
                field.input_type == "geo-targeting-google" ||
                field.input_type == 'google-ads-bidding' ||
                field.input_type == "facebook-audience-targeting" ||
                field.input_type == "snap-gender" ||
                field.input_type == "advanced-demographics" ||
                field.input_type == "snap-predefined-audiences" ||
                field.input_type == "pinterest-audience-targeting" ||
                field.input_type == "linkedin-audience-targeting" ||
                field.input_type == "file" ||
                field.input_type == "tritonAds-frequency-controls" ||
                field.input_type == 'google-ads-extension' ||
                field.input_type == 'tritonAds-teams-controls' ||
                field.input_type == 'yelpAds-categories' ||
                field.input_type == 'image-upload' ||
                field.input_type == "tiktok-audience-targeting" ||
                field.input_type == "tiktok-device-targeting"||
                field.input_type == "tiktok-languages-targeting" ||
                field.input_type == "xandr-invest-location" ||
                field.input_type == "links-and-main-cta" ||
                field.input_type == "facebook-audiences" ||
                field.input_type == "google-ad-manager-avail-units" ||
                field.input_type == "pinterest-geo-location" ||
                field.input_type == "final-approval" ||
                field.input_type == "facebook-page-id" ||
                field.input_type == "triton-creative-management" ||
                field.input_type == "triton-listener-targeting" ||
                field.input_type == "triton-geo-targeting" ||
                field.input_type == "linkedin-geo-targeting" ||
                field.input_type == "triton-time-targeting" ||
                field.input_type == "triton-content-targeting" ||
                field.input_type == "snapchat-pixel-controls" ||
                field.input_type == "pinterest-keyword" ||
                field.input_type == "accountability-group-label" ||
                field.input_type == "linkedin-campaign-objective" ||
                field.input_type == "tiktok-geo-targeting"
            ) {
                if (field.required == 1) {
                    let data = model[field.field_name];
                    if(data && _.isArray(data)) {
                        if(data.length > 0) {
                            validWidgets.push(true);
                        } else {
                            validWidgets.push(false);
                        }
                    } else if(data && _.isObject(data)){
                        if((data['timeZoneType'] && data['dayParts'].length > 0) || data['item_id'] || (data['ageVal'] && data['ageRangeVal'])) {
                            validWidgets.push(true);
                        } else {
                            validWidgets.push(false);
                        }
                    }
                }
            }
        });
        return {
            model: model,
            isValid: isValid,
            validateWidgets: validWidgets
        };
    };

    /*
     * Helper function to get time format from time string
     */
    var getTextTimeFormat = function (value) {
        const colon = value.indexOf(':');
        if (colon < 0) {
            return new Date();
        }
        let hour = value.substring(0, colon);
        hour = parseInt(hour);
        const min = value.substring(colon+1, colon+3);
        if (hour < 10) {
            hour = '0' + hour;
        } else if (hour > 23) {
            hour = 23;
        }
        const time = hour + ':' + min;
        return time;
    }
    /*
     * Helper function to harvest schema forms data for order, lineitem, flight and task pages
     */

    var getFamilyNestedCondition = function(field, model) {
        var condition = true;
        if (field.parentField) {
            var modelValue = model[field.parentField.field_name];
            if (Array.isArray(modelValue)) {
                if (Array.isArray(field.conditionValue)) {
                    condition = modelValue.some(oneVal => field.conditionValue.includes(oneVal));
                } else {
                    condition = modelValue.includes(field.conditionValue);
                }
            } else {
                if (Array.isArray(field.conditionValue)) {
                    condition = field.conditionValue.includes(modelValue);
                    if (!condition && (typeof modelValue === "boolean")) {
                        // If not found, and the parent is a boolean (checkbox), convert to 0 or 1 since automatic
                        // type conversion does not work with the includes function, and conditionValue is an array
                        // of 0 or 1 (of type string).
                        const strModelValue = (modelValue === true) ? '1' : '0';
                        condition = field.conditionValue.includes(strModelValue);
                    }
                } else {
                    condition = modelValue == (field.conditionValue);
                }
            }
            condition = getFamilyNestedCondition(field.parentField, model) && condition;
        }
        return condition;
    }

    service.harvestData = function(fields, form, model, fromPage, formParentChildInfo) {
        let data = {};
        let parameterName;
        data.overriddenFields = [];
        const skipped_types = [
            'file',
            'readonly',
            'calculated',
            'rollup-target',
            'custom-macro-mapping',
            'custom-macro-mapping-2',
            'seed-list-macros',
            'pos-matchback-details',
        ];

        _.each(fields, function(field) {
            // We don't need to pass this field values to backend
            if (skipped_types.indexOf(field.input_type) > -1) {
                return;
            }
            if (field.input_type == 'calculated-override' || field.input_type == 'distributed-target') {
                let hasOverrideFieldVal = false;
                for (let k = 0, len = form.length; k < len; k++) {
                    if (form[k].items) {
                        const overrideField = _.find(form[k].items, {field_name: field.field_name});
                        if (overrideField && overrideField.override) {
                            hasOverrideFieldVal = true;
                            data['overriddenFields'].push(field.id);
                        }
                        if (overrideField) {
                            break;
                        }
                    }
                }
                if (!hasOverrideFieldVal) {
                    return;
                }
            }
            switch (fromPage) {
                case 'lineItem':
                    parameterName = 'pf' + field.id;
                    break;
                case 'order':
                    parameterName = getParameterName(field);
                    break;
                case 'client':
                    parameterName = field.field_name;
                    break;
                default:
                    parameterName = 'ff' + field.id;
            }
            let condition = getFamilyNestedCondition(field, model);
            let formValue = model[field.field_name];
            let valueNotEmpty = Array.isArray(formValue) ? formValue.length > 0 : formValue;
            if (valueNotEmpty && condition) {
                if (field.lookup_content && field.input_type == "select2") {
                    data[parameterName] = service.getLookupContentIds(field.field_name, field.lookup_content, formValue.text, false, model, formParentChildInfo);
                } else if (field.lookup_content && field.input_type == "multiselect-custom") {
                    field.parameterName = parameterName;
                    var formLabelValues = [];
                    _.each(formValue, function(item){ if(item){ formLabelValues.push(item.label); } });
                    if (formLabelValues.length > 0) {
                        data[parameterName] = service.getLookupContentIds(field.field_name, field.lookup_content, formLabelValues, true, model, formParentChildInfo);
                    } else {
                        data[parameterName] = "";
                    }
                } else if (field.lookup_content && field.input_type == "multiselect") {
                    if (formValue.length > 0) {
                        data[parameterName] = service.getLookupContentIds(field.field_name, field.lookup_content, formValue, false, model, formParentChildInfo);
                    } else {
                        data[parameterName] = ""
                    }
                } else if (field.lookup_content &&
                    field.input_type !== "day-parting" &&
                    field.input_type !== "DFP" &&
                    field.input_type !== "dfp-frequency" &&
                    field.input_type !== "devices" &&
                    field.input_type !== "dfp_ad_units" &&
                    field.input_type !== "connection" &&
                    field.input_type !== "mobile-app" &&
                    field.input_type !== "device-capability" &&
                    field.input_type !== "geo-location" &&
                    field.input_type !== "ad-schedule" &&
                    field.input_type !== "google-ads-aud-targeting" &&
                    field.input_type !== "facebook-ads-location" &&
                    field.input_type !== "snapchat-ads-location" &&
                    field.input_type !== "xandr-invest-location" &&
                    field.input_type !== "facebookAds-frequency-controls" &&
                    field.input_type !== "snapChat-frequency-controls" &&
                    field.input_type !== "xandrInvest-frequency-controls" &&
                    field.input_type !== "pinterestAds-frequency-controls" &&
                    field.input_type !== "age-targeting" &&
                    field.input_type !== "snap-chat-age-targeting" &&
                    field.input_type !== "metric-select" &&
                    field.input_type !== "geo-targeting-google" &&
                    field.input_type !== "facebook-audience-targeting" &&
                    field.input_type !== "snap-gender" &&
                    field.input_type !== "advanced-demographics" &&
                    field.input_type !== "snap-predefined-audiences" &&
                    field.input_type !== "tritonAds-frequency-controls" &&
                    field.input_type !== "pinterest-audience-targeting" &&
                    field.input_type !== "linkedin-audience-targeting" &&
                    field.input_type !== "tritonAds-teams-controls" &&
                    field.input_type !== "yelpAds-categories" &&
                    field.input_type !== "image-upload" &&
                    field.input_type !== "tiktok-audience-targeting" &&
                    field.input_type !== "tiktok-device-targeting" &&
                    field.input_type !== "tiktok-languages-targeting" &&
                    field.input_type !== "links-and-main-cta" &&
                    field.input_type !== "facebook-audiences" &&
                    field.input_type !== "google-ad-manager-avail-units" &&
                    field.input_type !== "pinterest-geo-location" &&
                    field.input_type !== "triton-listener-targeting" &&
                    field.input_type !== "triton-geo-targeting" &&
                    field.input_type !== "final-approval" &&
                    field.input_type !== "facebook-page-id" &&
                    field.input_type !== "triton-creative-management" &&
                    field.input_type !== "linkedin-geo-targeting" &&
                    field.input_type !== "triton-time-targeting" &&
                    field.input_type !== "triton-content-targeting" &&
                    field.input_type !== "snapchat-pixel-controls" &&
                    field.input_type !== "tiktok-geo-targeting") {
                        data[parameterName] = service.getLookupContentIds(field.field_name, field.lookup_content, formValue, false, model, formParentChildInfo);
                } else if (field.data_type == "date") {
                    data[parameterName] = $filter('date')(formValue, 'yyyy-MM-dd');
                } else if (field.data_type == "time") {
                    formValue = field.input_type == 'text' ? getTextTimeFormat(formValue) : formValue;
                    data[parameterName] = String($filter('date')(formValue, "HH:mm"))+":00";
                } else if (field.data_type == "currency") {
                    if (formValue.contains("$")) {
                        formValue = formValue.replace('$', '')
                    }
                    data[parameterName] = formValue.replace(/[^\d.\-]/g, '');
                } else if (field.data_type == "percentage") {
                    if (formValue.contains("%")) {
                        formValue = formValue.replace('%', '');
                    }
                    data[parameterName] = formValue.replace(/[^\d.\-]/g, '');
                } else if (field.data_type == "integer" || field.data_type == "decimal") {
                    data[parameterName] = formValue.replace(/[^\d.\-]/g, '');
                } else if (field.input_type == 'location-picker' || field.input_type == 'location-picker-fb') {
                    data[parameterName] = angular.toJson(formValue);
                } else if (field.input_type == 'location-targeting') {
                    if (formValue.length) {
                        data[parameterName] = angular.toJson(formValue);
                    }
                }else if (field.input_type == 'multiple-mappings') {
                    if (formValue) {
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if(field.input_type == 'ad-group'){
                    if (formValue.length) {
                        var adGroupData = angular.copy(formValue);
                        data['adGroupField'] = {obj: formValue, field: field};
                        data[parameterName] = angular.toJson(adGroupData);
                    }
                }
                else if(field.input_type == 'google-ads-bidding'){
                    if (formValue) {
                        data[parameterName] = angular.toJson(formValue);
                    }
                }
                else if (field.input_type == 'facebook-create-ads') {
                    if (formValue.length) {
                        var fbCreateAdsData = angular.copy(formValue);
                        data['fbCreateAdGroup'] = fbCreateAdsData;
                        data[parameterName] = angular.toJson(fbCreateAdsData);
                    }
                } else if (field.input_type == 'shopping_adgroup_singleproduct') {
                    if (formValue.length) {
                        var shoppingAdgroupSingleProductData = angular.copy(formValue);
                        data[parameterName] = angular.toJson(shoppingAdgroupSingleProductData);
                    }
                } else if (field.input_type == 'shopping_adgroup_multiproduct') {
                    if (formValue.length) {
                        var shoppingAdgroupMultiproductData = angular.copy(formValue);
                        data['multiProductAdgroup'] = {obj: formValue, field: field};
                        data[parameterName] = angular.toJson(shoppingAdgroupMultiproductData);
                    }
                } else if(field.input_type == "connection"){
                    if(formValue && !_.isEmpty(formValue)){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        } else {
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type == "DFP"){
                    if(formValue.length){
                        if(typeof formValue === 'string'){
                            formValue = JSON.parse(formValue);
                        }
                        for(var k=0;k<formValue.length;k++){
                            var formValueArray = formValue[k];
                            for(var i=0;i<formValueArray.length;i++){
                                if(formValueArray[i].keyValue === null) {
                                    formValueArray.splice(i, 1);
                                    i--;
                                }
                                if(_.isEmpty(formValueArray[i].values)){
                                    formValueArray.splice(i, 1);
                                    i--;
                                }
                            }
                            if(formValue[k].length==0){
                                formValue.splice(k, 1);
                                k--;
                            }
                        }
                        _.each(formValue, function(data) {
                            _.each(data, function(lineItem) {
                                delete lineItem.isValuesLoaded;
                            })
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "dfp-frequency" || field.input_type == "facebookAds-frequency-controls" || field.input_type == "snapChat-frequency-controls" || field.input_type == "xandrInvest-frequency-controls" || field.input_type == "pinterestAds-frequency-controls" || field.input_type == "tritonAds-frequency-controls"){
                    if(formValue.length){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }

                } else if (field.input_type == "dfp_ad_units") {
                    if (formValue.length && formValue.length > 0) {
                        data[parameterName] = angular.toJson(formValue);
                    } else {
                        data[parameterName] = "";
                    }
                } else if(field.input_type == "devices" || field.input_type == "day-parting" || field.input_type == "mobile-app" || field.input_type == "device-capability") {
                    if(formValue && !_.isEmpty(formValue)){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type == "age-targeting") {
                    if(formValue){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if (field.input_type == "snap-chat-age-targeting") {
                    if (formValue) {
                        if (typeof formValue === 'string') {
                            data[parameterName] = formValue;
                        } else {
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if( field.input_type == "ad-schedule"){
                    if(formValue){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type === "metric-select"){
                    if(formValue){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type === "content-links"){
                    if(formValue){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type === "bridge-email-test"){
                    if(formValue){
                        if(typeof formValue === "string"){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type === "custom_file"){
                    if(formValue){
                        if (Array.isArray(formValue) && formValue[0]) {
                            formValue = formValue[0];

                            if (formValue.name) {
                                delete formValue.name;
                            }
                        }
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else{
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if(field.input_type == "google-ads-aud-targeting"){
                    if(formValue && !_.isEmpty(formValue)){
                        if(typeof formValue === 'string'){
                            data[parameterName] = formValue;
                        }else {
                            _.each(formValue.inMarketList, function(formValueInMarket) {
                                delete formValueInMarket.childrenList;
                            })
                            data[parameterName] = JSON.stringify(formValue);
                        }
                    }
                } else if(field.input_type == "inventory-filter"){
                    if(formValue.length){
                        _.each(formValue,function(key,index){
                            if(key.attributeType == "" || key.attributeValue == ""){
                                formValue.splice(index,1);
                                if(formValue.length != 0){
                                    formValue[index-1].isDisabled = false;
                                    formValue[index-1].isHide = false;
                                }
                                else{
                                    return;
                                }
                            }
                        });
                        if (typeof formValue === 'string') {
                            data[parameterName] = formValue;
                        } else {
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if (field.input_type == 'geo-location' ||
                    field.input_type == "facebook-ads-location" ||
                    field.input_type == "snapchat-ads-location" ||
                    field.input_type == "xandr-invest-location" ||
                    field.input_type == "image-upload" ||
                    field.input_type == "pinterest-geo-location" ||
                    field.input_type == "triton-geo-targeting" ||
                    field.input_type == "triton-creative-management" ||
                    field.input_type == "geo-targeting-google" ||
                    field.input_type == "linkedin-geo-targeting" ||
                    field.input_type == "triton-time-targeting" ||
                    field.input_type == "triton-content-targeting" ||
                    field.input_type == "snapchat-pixel-controls" ||
                    field.input_type == "accountability-group-label" ||
                    field.input_type == "tiktok-geo-targeting") {
                    if (formValue) {
                        data[parameterName] = angular.toJson(formValue);
                    }
                }else if(field.input_type == "facebook-audience-targeting"){
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.behaviourList;
                            delete item.demographicsList;
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "snap-gender") {
                    if (formValue) {
                        _.each(formValue, function (item) {
                            delete item.snapGenderList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "tritonAds-teams-controls") {
                    if (formValue) {
                        _.each(formValue, function (item) {
                            delete item.tritonTeamsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "yelpAds-categories") {
                    if (formValue) {
                        _.each(formValue, function (item) {
                            delete item.yelpCategoriesList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "advanced-demographics") {
                    if (formValue) {
                        _.each(formValue, function (item) {
                            delete item.demographicsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "snap-predefined-audiences") {
                    if (formValue) {
                        _.each(formValue, function (item) {
                            delete item.lifestyleList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if(field.input_type == "pinterest-audience-targeting"){
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "tiktok-audience-targeting") {
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }

                } else if (field.input_type == "tiktok-device-targeting") {
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == "tiktok-languages-targeting") {
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.languagesList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if(field.input_type == "linkedin-audience-targeting"){

                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                            delete item.demographicsList;
                            delete item.jobExperienceList;
                            delete item.companyList;
                            delete item.educationList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if(field.input_type == "facebook-audiences"){
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.customAudienceList;
                            delete item.savedAudienceList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type == 'google-ads-extension') {
                    if (formValue) {
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type === "links-and-main-cta") {
                    if (formValue) {
                        if (typeof formValue === "string") {
                            data[parameterName] = formValue;
                        } else {
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if (field.input_type === "final-approval") {
                    if (formValue) {
                        if (typeof formValue === "string") {
                            data[parameterName] = formValue;
                        } else {
                            data[parameterName] = angular.toJson(formValue);
                        }
                    }
                } else if (field.input_type === "pinterest-keyword") {
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else if (field.input_type === "linkedin-campaign-objective") {
                    if (formValue) {
                        _.each(formValue,function(item){
                            delete item.intrestsList;
                        })
                        data[parameterName] = angular.toJson(formValue);
                    }
                } else {
                    data[parameterName] = formValue;
                }
            }

            if (field.input_type == 'checkbox' && condition) {
                if (formValue) {
                    data[parameterName] = 1;
                } else {
                    data[parameterName] = 0;
                }
            } else if ((field.field_name == "salespersonId" || field.field_name == "salesperson_id") &&
                (formValue == "" || formValue === undefined)) {
                data[parameterName] = "";
            }

            if (!formValue && condition && field.field_name === "total_budget" && fromPage === 'tasks') {
                // In case we have a total_budget that's set to 0, or not set.  TO-4152.
                data[parameterName] = 0;
            }
            if(field.input_type == 'creative' && model[field.field_name]){
                let fieldValue = model[field.field_name];
                if(typeof fieldValue === 'string'){
                    data[parameterName] = fieldValue;
                } else {
                    let value = {
                        selectedImages:[],
                        thirdPartyCreatives:[],
                    }
                    // Uploaded files.
                    _.each(fieldValue.media, function(m) {
                        value.selectedImages.push({file_name: m.name});
                    });
                    // Selected files in creative lib
                    _.each(fieldValue.selectedImages, function(s) {
                        value.selectedImages.push({file_name: s.file_name});
                    });
                    data[parameterName] = JSON.stringify(value);
                    if(fieldValue.thirdPartyCreatives && fieldValue.thirdPartyCreatives.length >= 1){

                        _.each(fieldValue.thirdPartyCreatives, function(item) {
                            if(item.id != null){
                                value.thirdPartyCreatives.push({
                                    name: item.name,
                                    snippet: item.snippet,
                                    id: item.id
                                });
                            }else {
                                value.thirdPartyCreatives.push({
                                    name: item.name,
                                    snippet: item.snippet,
                                    id: null
                                });
                            }
                        });
                    }
                    data[parameterName] = JSON.stringify(value);
                }
            }

            // Apply a cluster override if one exists
            if (fromPage == 'order') {
                if (field.field_name == 'sales_region_id') {
                    //prevent clusterId being set as undefined if data[?] is undefined
                    if (data[parameterName]) {
                        data.clusterId = data[parameterName];
                    }
                }
                // For order type Id send both orderTypeId param and field id param
                if (field.field_name == 'order_type_id' && data["orderTypeId"]) {
                    data['ff' + field.id] = data["orderTypeId"];
                }
            }
        });
        return data;
    }

    service.getLookupContentIds = function(fieldName, lookupContent, formValue, is_custom_tag = false, model, formParentChildInfo = {}) {
        let contentIds = null;
        if (Array.isArray(formValue)) {
            contentIds = [];
            for (let i = 0; i < formValue.length; i++) {
                let lookupContentId = getLookupContentId(fieldName, lookupContent, formValue[i], model, formParentChildInfo);
                if (lookupContentId !== null) {
                    contentIds.push(lookupContentId);
                } else if (is_custom_tag) {
                    contentIds.push("CUST_"+formValue[i]);
                }
            }
        } else {
            contentIds = getLookupContentId(fieldName, lookupContent, formValue, model, formParentChildInfo);
        }
        return contentIds;
    };

    let getLookupContentId = function(fieldName, lookupContent, lookupContentValue, model, formParentChildInfo) {
        let parentLookupContentId = undefined;

        // See if this field is a child field in a lookup type parent-child relationship.  Find the parent field name
        // and current value, which we can use to discriminate which content id is the right one, in the (rare, but it
        // happens) scenario where there are multiple entries in this lookupContent's values with the same content value.
        // In this case we want to match the entry that has the right parent, and not any random one.
        if (formParentChildInfo && Object.keys(formParentChildInfo).length > 0) {
            const parentFieldName = _.findKey(formParentChildInfo, function(childArray) {
                // A given parent might have several children, so it's an array here.  See if our field is there.
                const child = _.find(childArray, {childFieldName: fieldName});
                return (child !== undefined);
            });
            if (parentFieldName) {
                const parentValue = model[parentFieldName];
                if (parentValue) {
                    // All children have the same parentLookupContent, so just take it off the first array item, even
                    // if it's that of another child!
                    const parentLookupContent = formParentChildInfo[parentFieldName][0].parentLookupContent;
                    const parentLookupContentEntry = _.find(parentLookupContent, {lookup_value: parentValue});
                    if (parentLookupContentEntry) {
                        parentLookupContentId = parentLookupContentEntry.id;
                    }
                }
            }
        }

        if (parentLookupContentId) {
            for (let i = 0; i < lookupContent.length; i++) {
                let content = lookupContent[i];
                if (lookupContentValue == content.lookup_value && parentLookupContentId == content.parent_content_key_source_id) {
                    return content.id;
                }
            }
        }
        // If we didn't find an entry when there is a parentLookupContentId, or if there is no parentLookupContentId,
        // then match without checking the parent.
        for (let i = 0; i < lookupContent.length; i++) {
            let content = lookupContent[i];
            if (lookupContentValue == content.lookup_value) {
                return content.id;
            }
        }
        return null;
    };

    const getFormFieldProperties = function(formField, model, isEditing, clientId, productObj, order, fromPage, lineItem = null) {
        let currentClusterId = order ?
            order.cluster_id[0] : (ClusterService.clusterIds[0] ? ClusterService.clusterIds[0] : null);
        let item = {};
        item.htmlClass = "col-lg-8 col-md-12 col-sm-12 col-xs-12";
        item.fieldHtmlClass = "col-sm-8 colReq-sm-8 col-xs-12 field-width select-field-width";
        item.labelHtmlClass = "col-sm-4 colReq-sm-4 col-xs-12 mandatory-field select-mandatory-field";
        item.field_name = formField.field_name;
        item.field_id = formField.id;
        item.showLongText = false;
        if (formField && formField.is_editable) {
            item.readonly = false;
            if(formField.is_editable == "disable") {
                item.readonly = true;
            } else if(isEditing && formField.is_editable == "add") {
                item.readonly = true;
            } else if(!isEditing && formField.is_editable == "edit") {
                item.readonly = true;
            }
        }
        switch (formField.input_type) {
            case "textarea":
                item.type = "ioTextArea";
                break;
            case "textplain-area":
                item.type = "ioTextplainArea";
                break;
            case "select":
                item.showLongText = (formField.show_long_text == '1') ? true : false;
                // To avoid adding extra empty value option
                // We have A empty value option, its value is empty string
                item.destroyStrategy = '';
                break;
            case "select2":
                item.showLongText = (formField.show_long_text == '1') ? true : false;
                item.type = "uiselect2";
                item.placeholder = "Select value";
                if (formField.__select2FieldCallback__) {
                    item.select2Callback = formField.__select2FieldCallback__;
                }
                break;
            case "multiselect":
                item.type = "uimultiselect";
                item.placeholder = "Select one or more values";
                var itemOptions = {};
                itemOptions.uiClass = "short_select ui-select-choices-list";
                if(formField.enable_type_ahead == "1"){
                    itemOptions.async = function(options, search){
                        var lookupContent = service.getLookupContentSearch(formField.lookup_type_id, currentClusterId, search);
                        lookupContent.then(function(lookupContents) {
                            _.each(lookupContents.data, function(lookupContentObj){
                                var contentObj = _.findIndex(formField.lookup_content, {id: lookupContentObj.id});
                                if(contentObj===-1){
                                    formField.lookup_content.push(lookupContentObj);
                                }
                            });
                        }, function(error) {});
                        return lookupContent;
                    };
                }
                item.options = itemOptions;
                item.destroyStrategy = [];
                break;
            case "multiselect-custom":
                item.showLongText = (formField.show_long_text == '1') ? true : false;
                item.type = "uimultiselectcustom";
                item.placeholder = "Select one or more values";
                var itemOptions = {};
                itemOptions.uiClass = "short_select ui-select-choices-list";
                if(formField.enable_type_ahead == "1"){
                    itemOptions.async = function(options, search){
                        var lookupContent = service.getLookupContentSearch(formField.lookup_type_id, currentClusterId, search);
                        lookupContent.then(function(lookupContents) {
                            _.each(lookupContents.data, function(lookupContentObj){
                                var contentObj = _.findIndex(formField.lookup_content, {id: lookupContentObj.id});
                                if(contentObj===-1){
                                    formField.lookup_content.push(lookupContentObj);
                                }
                            });
                        }, function(error) {});
                        return lookupContent;
                    };
                }
                item.options = itemOptions;
                item.destroyStrategy = [];
                break;
            case "file":
                item.key = "fileUpload";
                item.type = "dfFile";
                item.title = formField.display_name ? formField.display_name : 'Choose File';
                item.accType = "image/*";
                item.multiple = "true";
                item.keepMultiple = "true";
                item.htmlClass = "col-lg-8 col-md-12 col-xs-12 col-sm-12";
                item.validationMessage = {
                    "default": 'Required'
                }
                if(isEditing == true && model[formField.field_name]) {
                    let fileList = [];
                    // item.fileObjList can only be set with order attributes not UI, when form page is order
                    item.fileObjList = fromPage == 'order' ? order[formField.field_name] : model[formField.field_name];
                    _.each(model[formField.field_name], function(fileObj){
                        if (fileObj.type?.length > 0) {
                            // keep the file info to be uploaded
                            fileList.push(fileObj);
                        } else {
                            // fileObj.file_name is working for first time form loading
                            // fileObj.name is working for switch client
                            const file_name = fileObj.file_name ? fileObj.file_name : fileObj.name;
                            const file = { name: file_name };
                            fileList.push(file);
                        }
                    });
                    model[formField.field_name] = fileList;
                }
                break;
            case "creative":
                item.key = "creativeUpload";
                item.type = "creative";
                item.title = formField.display_name ? formField.display_name : 'Choose File';
                item.htmlClass = "col-lg-8 col-md-12 col-xs-12";
                item.style = 'btn-primary';
                item.clientId = clientId;
                item.getFormClientId = function(){
                    if(item.clientId){
                        return item.clientId;
                    }
                    if(service.formClients && model.client_id){
                        var clientObj = _.find(service.formClients, {lookup_value: model.client_id});
                        if(clientObj){
                            return clientObj.id;
                        }
                    }
                    return null;
                },
                item.validationMessage = {
                    "default": 'Required'
                }
                break;
            case "timeselect":
                item.type = "timePicker";
                item.meridian = "true";
                item.title = formField.display_name;
                if (isEditing && model[formField.field_name]) {
                    let initialTime = new Date();
                    let timeData = model[formField.field_name];
                    if (typeof timeData === 'object') {
                        initialTime = timeData;
                    } else if (timeData.indexOf(":") && (timeData.indexOf(" AM") ||
                        timeData.indexOf(" PM"))){ // hh:mm AM format
                        timeData = timeData.split(" ");
                        var ampm = timeData[1];
                        timeData = timeData[0].split(":");
                        timeData[0] = (ampm === "PM")?(parseInt(timeData[0])+12):parseInt(timeData[0]);
                        initialTime.setHours(timeData[0]);
                        initialTime.setMinutes(parseInt(timeData[1]));
                    } else if (timeData.indexOf(":")>0 && timeData.indexOf(":", 3)>3) {
                        timeData = timeData.split(":");
                        initialTime.setHours(parseInt(timeData[0]));
                        initialTime.setMinutes(parseInt(timeData[1]));
                    }
                    initialTime.setSeconds(0);
                    model[formField.field_name] = initialTime;
                }
                break;
            case "phone":
                item.type = "phoneNumber";
                break;
            case "currency":
                item.type = "currency";
                item.validationMessage = {
                    'default': 'Invalid Currency value',
                }
                item.$validators = {
                    currencyValid: function(value) {
                        if (angular.isString(value)) {
                            if(value === '') {
                                return true;
                            }
                            if (value.contains("$")) {
                                value = value.substring(1);
                            }
                            let regex = /([0-9]+[.,]*)+/;
                            if (!regex.test(value)) {
                                return false;
                            } else {
                                return true;
                            }
                        }
                        return true;
                    }
                }
                break;
            case "calculated":
                item.type = "dynamicCalculation";
                getRequiredFields(formField.id, fromPage).then(function(success) {
                    success.requiredFieldIds.unshift(formField.id);
                    var ids = success.requiredFieldIds.toString();
                    item.onClick = "calculate('" + ids + "')";
                    item.fieldIds = ids;
                }, function(error) {
                    console.log("error")
                });
                if (formField.data_type == 'currency' && model[formField.field_name]) {
                    model[formField.field_name] = FieldTransformer.transformCurrency(model[formField.field_name]);
                }
                if (formField.data_type == 'integer' && model[formField.field_name]) {
                    model[formField.field_name] = service.numberFormating(model[formField.field_name], 0);
                }
                if (formField.data_type == 'percentage' && model[formField.field_name]) {
                    model[formField.field_name] = String(model[formField.field_name]) + '%';
                }
                if (formField.data_type == 'hyperlink' && model[formField.field_name]) {
                    // remove html tag from field value for buildForm
                    model[formField.field_name] = model[formField.field_name].replace(/(<([^>]+)>)/ig, '');
                }
                break;
            case "calculated-override":
                item.type = "dynamicCalculation";
                item.showOverride = true;
                item.override = false;
                if (isEditing && model["overridden_fields"] && model["overridden_fields"].indexOf(formField.field_name) !== -1) {
                    item.override = true;
                }
                if (formField.data_type == 'currency' && model[formField.field_name]) {
                    model[formField.field_name] = FieldTransformer.transformCurrency(model[formField.field_name]);
                }
                if (formField.data_type == 'integer' && model[formField.field_name]) {
                    model[formField.field_name] = service.numberFormating(model[formField.field_name], 0);
                }
                if (formField.data_type == 'percentage' && model[formField.field_name]) {
                    model[formField.field_name] = String(model[formField.field_name]) + '%';
                }
                if (formField.data_type == 'hyperlink' && model[formField.field_name]) {
                    // remove html tag from field value for buildForm
                    model[formField.field_name] = model[formField.field_name].replace(/(<([^>]+)>)/ig, '');
                }
                getRequiredFields(formField.id, fromPage).then(function(success) {
                    success.requiredFieldIds.unshift(formField.id);
                    var ids = success.requiredFieldIds.toString();
                    item.onClick = "calculate('" + ids + "')";
                    item.fieldIds = ids;
                }, function(error) {
                    console.log("error")
                });
                break;
            case "calculate-all":
                item.type = "button";
                item.title = "Calculate All";
                item.htmlClass = "btn col-lg-8 col-md-12 col-xs-12";
                item.onClick = "calculateAllFields()";
                item.style = 'btn-primary';
                break;
            case "custom_function":
                item.type = "button";
                if (formField.display_name) {
                    item.title = formField.display_name;
                } else {
                    item.title = "";
                }
                item.htmlClass = "btn col-lg-8 col-md-12 col-xs-12";
                item.onClick = formField.formula;
                item.style = 'btn-primary';
                break;
            case "custom_file":
                if (formField.display_name) {
                    item.title = formField.display_name;
                } else {
                    item.title = "";
                }
                item.key = "customFile";
                item.type = "dfFile";
                item.accType = "image/*";
                item.multiple = "false";
                item.keepMultiple = "true";
                item.htmlClass = "col-lg-8 col-md-12 col-xs-12";
                item.validationMessage = {
                    "default": 'Required'
                }
                if (isEditing && model[formField.field_name]) {
                    // Make sure the field contains an array, and that a field_name from the backend is transformed
                    // into the 'name'.
                    if (!Array.isArray(model[formField.field_name])) {
                        let field_value = model[formField.field_name];

                        if (field_value.file_name) {
                            field_value.name = field_value.file_name;
                        }
                        model[formField.field_name] = [field_value];
                    } else {
                        model[formField.field_name] = model[formField.field_name].map(function(singleFile) {
                            if (singleFile.file_name) {
                                singleFile.name = singleFile.file_name;
                            }
                            return singleFile;
                        });
                    }
                }
                break;
            case "readonly":
            case "rollup-target":
                // Note that for rollup-target which are also of the 'date' data-type, this gets overwritten later.
                item.type = "formConstant";
                break;
            case "distributed-target":
                item.type = "dynamicCalculation";
                item.showOverride = true;
                item.isDistributedTarget = true;
                item.override = false;
                if (isEditing && model["overridden_fields"] && model["overridden_fields"].indexOf(formField.field_name) !== -1) {
                    item.override = true;
                }
                if (formField.data_type == 'currency' && model[formField.field_name]) {
                    model[formField.field_name] = FieldTransformer.transformCurrency(model[formField.field_name]);
                }
                break;
            case "geo-location":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "geoLocation";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "facebook-ads-location":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "facebookAdsLocationWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "snapchat-ads-location":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "snapchatAdsLocationWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "geo-targeting-google":
            case "triton-geo-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "geoTargetingGoogle";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                break;
            case "triton-time-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tritonTimeTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                break;
            case "triton-content-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tritonContentTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                break;
            case "location-picker":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 geo-location-width";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "locationPicker";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.client_address = "";
                if (order) {
                    item.client_address += (order.client_state && order.client_state.length > 0) ? order.client_state : "";
                    item.client_address += (order.client_zip && order.client_zip.length > 0) ? " " + order.client_zip : "";
                    item.client_address += (order.client_country && order.client_country.length > 0) ? ", " + order.client_country : "";
                }
                break;
            case "location-picker-fb":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 geo-location-width";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.clusterId=currentClusterId;
                item.type = "locationPickerFb";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.client_address = "";
                if (order) {
                    item.client_address += (order.client_state && order.client_state.length > 0) ? order.client_state : "";
                    item.client_address += (order.client_zip && order.client_zip.length > 0) ? " " + order.client_zip : "";
                    item.client_address += (order.client_country && order.client_country.length > 0) ? ", " + order.client_country : "";
                }
                break;
            case "location-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 geo-location-width";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "locationTargeting";
                item.clientId = clientId;
                item.title = formField.display_name;
                break;
            case "ad-group":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ad-group";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "adGroup";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                item.isEdit = isEditing;
                break;
            case "google-ads-bidding":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ad-group";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "googleAdsBidding";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                if(lineItem){
                    item.googleAdsCampaignId = lineItem.google_ads_campaign_id;
                }
                break;
            case "facebook-create-ads":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ad-group";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "facebookCreateAds";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                break;
            case "facebook-audience-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "facebookAudienceTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "facebook-audiences":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "facebookAudiences";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "snap-gender":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "snapGender";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "tritonAds-teams-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tritonTeams";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "yelpAds-categories":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "yelpCategories";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "image-upload":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "imageUpload";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "advanced-demographics":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "advancedDemographics";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "snap-predefined-audiences":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "snapPredefinedAudiences";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "pinterest-audience-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "pinterestAudienceTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "tiktok-audience-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tiktokAudienceTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "tiktok-device-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tiktokDeviceTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "tiktok-languages-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tiktokLanguagesTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "linkedin-audience-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "linkedinAudienceTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "shopping_adgroup_singleproduct":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "shoppingAdgroupSingleProduct";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "shopping_adgroup_multiproduct":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "shoppingAdgroupMultiproduct";
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                if (productObj) {
                    item.productId = productObj.id;
                }
                item.lookup = '1';
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.isEdit = isEditing;
                break;
            case "DFP":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "dfpWidget";
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                if (productObj) {
                    item.productId = productObj.id;
                }
                item.lookup = '1';
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.isEdit = isEditing;
                item.fromPage = fromPage;
                break;
            case "day-parting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "dayPartingTargeting";
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                if (productObj) {
                    item.productId = productObj.id;
                }
                item.lookup = '1';
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "ad-schedule":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "adScheduleTargeting";
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                if (productObj) {
                    item.productId = productObj.id;
                }
                item.lookup = '1';
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "dfp-frequency":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "dfpFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "facebookAds-frequency-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "facebookAdsFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "snapChat-frequency-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "snapChatFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "xandrInvest-frequency-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "xandrInvestFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "tritonAds-frequency-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "tritonAdsFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "triton-listener-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tritonListenerTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "geo-targeting-triton":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tritonGeoTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "pinterestAds-frequency-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "pinterestAdsFrequencyWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "pos-matchback-details":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "posMatchbackDetails";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.isEdit = isEditing;
                break;
          case "tiktok-geo-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "tiktokGeoTargeting";
                if (formField.display_name) {
                  item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                break;
            case "custom-macro-mapping":
            case "custom-macro-mapping-2":
            case "seed-list-macros":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                switch (formField.input_type) {
                    case "custom-macro-mapping":
                        item.type = "customMacroMapping";
                        break;
                    case "custom-macro-mapping-2":
                        item.type = "customMacroMapping2";
                        break;
                    case "seed-list-macros":
                        item.type = "seedListMacros";
                }
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                if (model["__audience_macro_mappings"]) {
                    item.audienceMacroMappings = model["__audience_macro_mappings"];
                }
                if (model["__audience_match_mappings"]) {
                    item.audienceMatchMappings = model["__audience_match_mappings"];
                }
                if (model["__email_macros"]) {
                    item.emailMacros = model["__email_macros"];
                }
                item.isEdit = isEditing;
                if (model["__html_validation_status"]) {
                    item.htmlValidationStatus = model["__html_validation_status"];
                }
                item.enableMapping = (fromPage !== "order");
                item.seedListMode = (fromPage === "task");
                break;
            case "google-ads-aud-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "googleAdsAudTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.isEdit = isEditing;
                break;
            case "inventory-filter":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 col-md-8 col-lg-9";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.type = "inventoryFilterWidget";
                if (order) {
                    item.clusterId = currentClusterId;
                }
                item.clientId = clientId;
                if (productObj) {
                    item.productId = productObj.id;
                }
                item.lookup = '1';
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "devices":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "devicesTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "device-capability":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "deviceCapability";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "dfp_ad_units":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "dfpAdUnits";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "connection":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "connectionTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "mobile-app":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-md-8 col-sm-8 col-xs-12 devicesWidth";
                item.labelHtmlClass = "col-lg-3 col-md-4 col-sm-4 col-xs-12";
                item.clusterId = currentClusterId;
                item.type = "mobileAppsTargeting";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "emoji":
                item.fieldHtmlClass = "col-sm-8 col-lg-4 col-xs-12 emoji-width";
                item.type = "emojiPicker";
                break;
            case "audience-segments":
                item.htmlClass = "col-lg-8 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12 segments-width";
                item.labelHtmlClass = "col-sm-4 col-xs-12";
                item.type = "audienceSegments";
                break;
            case 'service-mapper':
                if (productObj.service_id) {
                    item.isServiceId = true;
                } else {
                    item.isServiceId = false;
                }
                item.htmlClass = "col-lg-8 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-xs-12";
                item.labelHtmlClass = "col-sm-4 col-xs-12";
                item.type = "serviceMapper";
                item.clientId = clientId;
                item.serviceId = productObj.service_id;
                item.clusterId = currentClusterId;
                break;
            case "metric-select":
                item.htmlClass = "col-lg-8 col-md-12 col-sm-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 select-field-width";
                item.labelHtmlClass = "col-sm-4 col-md-4 col-sm-4 col-xs-12";
                item.type = "metricSelect";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "content-links":
                item.htmlClass = "col-lg-8 col-md-12 col-sm-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 select-field-width";
                item.labelHtmlClass = "col-sm-4 col-md-4 col-sm-4 col-xs-12";
                item.type = "contentLinks";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case "multiple-mappings":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "multipleMappings";
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                if(productObj && productObj.ta_service_id) {
                    item.serviceId = productObj.ta_service_id;
                }

                item.title = formField.display_name;
                break;
            case 'percentage':
                item.type = "percentage";
                item.validationMessage = {
                    'default': 'Invalid value',
                }
                item.$validators = {
                    isPercentageValid: function(value) {
                        let percentage = value

                        // percentage may be undefined when form is built
                        if (typeof percentage !== 'string' || percentage === '') {
                            return true;
                        }

                        if (percentage.startsWith('-')) {
                            percentage = percentage.slice(1)
                        }

                        if (percentage.startsWith('%')) {
                            percentage = percentage.slice(1)
                        } else if (percentage.endsWith('%')) {
                            percentage = percentage.slice(0, -1)
                        }

                        return /^[0-9.]+$/.test(percentage);
                    }
                }
                break;
            case 'checkbox':
                item.validationMessage = {
                    isValidCheckbox: "Required"
                }
                item.$validators = {
                    isValidCheckbox: function(value, formValue, model, form) {
                        if(form.required===true && formValue!==true){
                            return false;
                        }
                        return true;
                    }
                }
                break;
            case 'age-targeting':
                item.type = "ageTragetingFb";
                if(formField && formField.is_editable) {
                    item.readonly = false;
                    if(formField.is_editable == "disable") {
                        item.readonly = true;
                    } else if(isEditing && formField.is_editable == "add") {
                        item.readonly = true;
                    } else if(!isEditing && formField.is_editable == "edit") {
                        item.readonly = true;
                    }
                }
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case 'snap-chat-age-targeting':
                item.type = "snapChatAgeTargeting";
                if(formField && formField.is_editable) {
                    item.readonly = false;
                    if(formField.is_editable == "disable") {
                        item.readonly = true;
                    } else if(isEditing && formField.is_editable == "add") {
                        item.readonly = true;
                    } else if(!isEditing && formField.is_editable == "edit") {
                        item.readonly = true;
                    }
                }
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                break;
            case 'text':
                if (formField.data_type == 'integer') {
                    item.type = "integerPicker";
                    item.validationMessage = {
                        'default': formField.display_name + ' must be a valid integer',
                    }
                    item.$validators = {
                        isNumber: function(value) {
                            if (value && isNaN(value.replace(/,/g, ''))) {
                                return false;
                            }
                            return true;
                        }
                    }
                } else if (formField.data_type == 'decimal') {
                    item.type = "decimalPicker";
                    item.validationMessage = {
                        'default': formField.display_name + ' must be a valid decimal',
                    }
                    item.$validators = {
                        isNumber: function(value) {
                            if (value && isNaN(value.replace(/,/g, ''))) {
                                return false;
                            }
                            return true;
                        }
                    }
                } else if (formField.data_type == 'hyperlink') {
                    item.type = "hyperlinkPicker";
                    item.validationMessage = {
                        'default': formField.display_name + ' must be a valid url',
                    }
                    item.$validators = {
                        isHyperlink: function(value) {
                            if (value) {
                                const urlPattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
                                return urlPattern.test(value);
                            }
                            return true;
                        }
                    }
                    if (model[formField.field_name]) {
                        // remove html tag from field value for buildForm
                        model[formField.field_name] = model[formField.field_name].replace(/(<([^>]+)>)/ig, '');
                    }
                }
                break;
            case "google-ads-extension":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 col-md-8 col-lg-9 col-xs-12 ad-group";
                item.labelHtmlClass = "col-sm-4 col-lg-3 col-md-4 col-xs-12";
                item.type = "googleAdsExtension";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                break;
            case "bridge-email-test":
                item.htmlClass = "col-lg-8 col-md-12 col-sm-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 select-field-width";
                item.labelHtmlClass = "col-sm-4 col-md-4 col-sm-4 col-xs-12";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.type = "bridgeEmailTest";
                break;
            case "xandr-invest-location":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "xandrInvestLocationWidget";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                break;
            case "links-and-main-cta":
                item.htmlClass = "col-lg-8 col-md-12 col-sm-12 col-xs-12";
                item.fieldHtmlClass = "col-sm-8 select-field-width";
                item.labelHtmlClass = "col-sm-4 col-md-4 col-sm-4 col-xs-12";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.type = "linksAndMainCta";
                break;
            case "final-approval":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.type = "finalApproval";
                break;
            case "google-ad-manager-avail-units":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                    item.orderId=order;
                }
                item.type = "googleAdManagerAvailUnits";
                break;
            case "pinterest-geo-location":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                    item.orderId=order;
                }
                item.type = "pinterestGeoLocation";
                break;
            case "facebook-page-id":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                item.type = "facebookPageId";
                item.isEdit = isEditing;
                break;
            case "triton-creative-management":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                item.type = "tritonCreativeManagement";
                item.isEdit = isEditing;
                break;
            case "linkedin-geo-targeting":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                item.type = "linkedinGeoTargeting";
                item.isEdit = isEditing;
                break;
            case "snapchat-pixel-controls":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 p-0";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.clientId = clientId;
                item.type = "snapchatPixelControls";
                item.isEdit = isEditing;
                break;
            case "pinterest-keyword":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "pinterestKeyword";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "accountability-group-label":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-4 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "accountabilityGroupLabel";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
            case "linkedin-campaign-objective":
                item.htmlClass = "col-lg-11 col-md-12 col-xs-12";
                item.fieldHtmlClass = "col-lg-9 col-xs-12 col-sm-8 col-md-8 geo-location-width";
                item.labelHtmlClass = "col-xs-12 col-sm-4 col-md-4 col-lg-3";
                item.type = "linkedinCampaignObjective";
                if (formField.display_name) {
                    item.title = formField.display_name;
                }
                item.clusterId = currentClusterId;
                item.isEdit = isEditing;
                item.clientId = clientId;
                break;
        }

        if (formField.data_type == "date") {
            let date_moment_tool = require('moment-business-days');
            item.type = "datePicker";
            item.field_name = formField.field_name;
            item.isEditing = isEditing;
            item.isRequired = (formField.required == '1');
            item.dateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                showWeeks: false
            };
            if (formField.input_type == 'rollup-target') {
                item.readonly = true;
            }

            if (isEditing) {
                let d = model[formField.field_name];
                if (d && typeof d === 'string') {
                    const parts = d.split('-');
                    model[formField.field_name] = new Date(parts[0], parts[1] - 1, parts[2]);
                }
            };
            if (formField.field_name == 'start_date') {
                item.fromPage = fromPage;
                item.validationMessage = {
                    'default': fromPage + ' start date cannot be after the end date.',
                };
                if (formField.date_rules) {
                    item.dateRules = JSON.parse(formField.date_rules);
                }
                item.currentDate = new Date();
                let dateMin;
                item.orderStartDateIsRollupTarget = (order && order.__start_date_is_rollup_target);
                item.orderEndDateIsRollupTarget = (order && order.__end_date_is_rollup_target);
                //Date Rule validation for start and end dates
                switch (fromPage) {
                    case 'order':
                        dateMin = angular.copy(item.currentDate);
                        break;
                    case 'lineItem':
                        if (order && order.start_date) {
                            item.orderStartDate = order.start_date;
                        }
                        if (order && order.end_date) {
                            item.orderEndDate = order.end_date;
                        }
                        if (item.dateRules) {
                            let date = item[item.dateRules.dependency];
                            date = typeof date === 'string' ? date.replace(/-/g,',') : date;
                            dateMin = new Date(angular.copy(date));
                        }
                        break;
                        /*
                    case 'flight':
                        if (order && order.start_date) {
                            item.orderStartDate = order.start_date;
                        }
                        if (order && order.end_date) {
                            item.orderEndDate = order.end_date;
                        }
                        if (lineItem && lineItem.start_date) {
                            item.lineItemStartDate = lineItem.start_date;
                        }
                        if (lineItem && lineItem.end_date) {
                            item.lineItemEndDate = lineItem.end_date;
                        }
                        if (item.dateRules && item.dateRules.dependency == 'currentDate') {
                            dateMin = angular.copy(item.currentDate);
                        } else if (item.dateRules) {
                            dateMin = new Date(angular.copy(item[item.dateRules.dependency]));
                        }
                        break;
                        */
                }
                if (item.dateRules && fromPage != 'flight') {   // TODO remove check when re-enabling flights...
                    let numDays = item.dateRules.numDays;
                    if (item.dateRules.validateOn == 'after') {
                        if (item.dateRules.businessDays) {
                            item.minDate = date_moment_tool(dateMin.toLocaleDateString(), 'MM-DD-YYYY').businessAdd(numDays)._d;
                        } else {
                            item.minDate = dateMin.setDate(dateMin.getDate() + numDays);
                        }
                    } else if (item.dateRules.validateOn == 'before') {
                        if (item.dateRules.businessDays) {
                            item.minDate = date_moment_tool(dateMin.toLocaleDateString(), 'MM-DD-YYYY').businessSubtract(numDays)._d;
                        } else {
                            item.minDate = dateMin.setDate(dateMin.getDate() - numDays);
                        }
                    }
                    if (formField.default_value && new Date(formField.default_value) < new Date(item.minDate)) {
                        formField.default_value = new Date(item.minDate).toISOString();
                    }
                }
                // Validations for date picker
                item.$validators = {
                    isValidStartDate: function(value, formValue, model, form, parentForm) {
                        if (value) {
                            let endDateControl = (parentForm.$error.isValidEndDate)?parentForm.$error.isValidEndDate[0]:((parentForm.$$success.isValidEndDate)?parentForm.$$success.isValidEndDate[0]:null);
                            let endDateVal = (endDateControl!==null && endDateControl.$viewValue)?endDateControl.$viewValue:model.end_date;
                            // new Data('2024-05-08') might equal Tue May 07 2024 20:00:00 GMT-0400 (Eastern Daylight Time)
                            // new Data('2024-05-08 00:00:00') might equal Wed May 08 2024 00:00:00 GMT-0400 (Eastern Daylight Time)
                            if (endDateVal && typeof endDateVal == 'string' && endDateVal.indexOf(':') == -1) {
                                endDateVal = endDateVal + ' 00:00:00';
                            }
                            if(form.endDate_dateRules && (
                                 form.endDate_dateRules.dependency == 'orderStartDate' ||
                                 form.endDate_dateRules.dependency == 'lineItemStartDate' ||
                                 form.endDate_dateRules.dependency == 'flightStartDate'
                            )) {
                                if(endDateVal) {
                                    let startDate = new Date(value);
                                    let endDate = new Date(endDateVal);
                                    const diffTime = Math.abs(endDate - startDate);
                                    const numDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                    if(form.endDate_dateRules.numDays > numDays) {
                                        form.validationMessage.default = form.fromPage +
                                            " date rules are not satisfied, too close to the end date";
                                        return false;
                                    }
                                }
                            }
                            if (endDateVal && new Date(endDateVal) < new Date(value)) {
                                form.validationMessage.default = form.fromPage + ' start date cannot be after the end date.';
                                return false;
                            }
                            //Line Item start and End Days will always be dependent on order start and end dates.
                            let orderEndDateSatisfied = true;
                            if (form.fromPage == 'lineItem' && form.orderStartDate && form.orderEndDate) {
                                if (typeof form.orderStartDate === 'string' && !form.orderStartDateIsRollupTarget) {
                                    const sdParts = form.orderStartDate.split('-');
                                    let startDate = new Date(sdParts[0], sdParts[1] - 1, sdParts[2]);
                                    const edParts = form.orderEndDate.split('-');
                                    let endDate = new Date(edParts[0], edParts[1] - 1, edParts[2])
                                    if (new Date(value).setHours(0, 0, 0, 0) < startDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Line item start date cannot be before the order start date";
                                        }
                                        return false;
                                    } else if (new Date(value).setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Line item start date cannot be after the order end date";
                                        }
                                        return false;
                                    }
                                }
                                if (typeof form.orderEndDate === 'string' && endDateVal && !form.orderEndDateIsRollupTarget) {
                                    const parts = form.orderEndDate.split('-');
                                    let orderEndDate = new Date(parts[0], parts[1] - 1, parts[2]);
                                    if (new Date(endDateVal).setHours(0, 0, 0, 0) > orderEndDate.setHours(0, 0, 0, 0)) {
                                        orderEndDateSatisfied = false;
                                    }
                                }
                            } /* else if (form.fromPage == 'flight' && form.lineItemStartDate && form.lineItemEndDate) {
                                if (typeof form.lineItemStartDate === 'string') {
                                    var sdParts = form.lineItemStartDate.split('-');
                                    var startDate = new Date(sdParts[0], sdParts[1] - 1, sdParts[2]);
                                    var edParts = form.lineItemEndDate.split('-');
                                    var endDate = new Date(edParts[0], edParts[1] - 1, edParts[2])
                                    if (new Date(value).setHours(0, 0, 0, 0) < startDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Flight start date cannot be before the line item start date";
                                        }
                                        return false;
                                    } else if (new Date(value).setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Flight start date cannot be after the line item end date";
                                        }
                                        return false;
                                    }
                                }
                            } */

                            //reset endDate
                            if(endDateControl!==null && endDateVal){
                                if(new Date(endDateVal) >= new Date(value) && orderEndDateSatisfied){
                                    endDateControl.$setValidity('isValidEndDate', true, endDateControl);
                                    if(!model.end_date){
                                        model.end_date = new Date(endDateVal);
                                    }
                                }else{
                                    endDateControl.$setValidity('isValidEndDate', false, endDateControl);
                                }
                            }
                        }
                        return true;
                    }
                }
            } else if (formField.field_name == 'end_date') {
                item.fromPage = fromPage;
                item.validationMessage = {
                    'default': fromPage + ' end date cannot be before the start date.',
                };
                if (formField.date_rules) {
                    item.dateRules = JSON.parse(formField.date_rules);
                }
                item.currentDate = new Date();
                let dateMinEnd;
                item.orderStartDateIsRollupTarget = (order && order.__start_date_is_rollup_target);
                item.orderEndDateIsRollupTarget = (order && order.__end_date_is_rollup_target);
                //Date Rule validation for start and end dates
                switch (fromPage) {
                    case 'order':
                        if (item.dateRules) {
                            if (item.dateRules.dependency == 'orderStartDate') {
                                let startDate = model['start_date'] ? model['start_date'] : item.currentDate;
                                dateMinEnd = new Date(angular.copy(startDate));
                            } else {
                                dateMinEnd = new Date(angular.copy(item[item.dateRules.dependency]));
                            }
                        }
                        break;
                    case 'lineItem':
                        if (order && order.start_date) {
                            item.orderStartDate = order.start_date;
                        }
                        if (order && order.end_date) {
                            item.orderEndDate = order.end_date;
                        }
                        if (item.dateRules) {
                             if (item.dateRules.dependency == 'lineItemStartDate') {
                                 let startDate = model['start_date'] ? model['start_date'] : item.currentDate;
                                dateMinEnd = new Date(angular.copy(startDate));
                             } else {
                                 let date = item[item.dateRules.dependency];
                                 date = typeof date === 'string' ? date.replace(/-/g,',') : date;
                                 dateMinEnd = new Date(angular.copy(date));
                             }
                        }
                        break;
                        /*
                    case 'flight':
                        if (order && order.start_date) {
                            item.orderStartDate = order.start_date;
                        }
                        if (order && order.end_date) {
                            item.orderEndDate = order.end_date;
                        }
                        if (lineItem && lineItem.start_date) {
                            item.lineItemStartDate = lineItem.start_date;
                        }
                        if (lineItem && lineItem.end_date) {
                            item.lineItemEndDate = lineItem.end_date;
                        }
                        if (item.dateRules) {
                            if (item.dateRules.dependency == 'flightStartDate') {
                                let startDate = model['start_date'] ? model['start_date'] : item.currentDate;
                                dateMinEnd = new Date(angular.copy(startDate));
                            } else {
                                dateMinEnd = new Date(angular.copy(item[item.dateRules.dependency]));
                            }
                        }
                        break;
                        */
                }
                if (item.dateRules && fromPage != 'flight') {    // TODO remove this check when enabling flight date checking back
                    let numDays = item.dateRules.numDays;
                    if (item.dateRules.validateOn == 'after') {
                        if (item.dateRules.businessDays) {
                            item.minDate = date_moment_tool(dateMinEnd.toLocaleDateString(), 'MM-DD-YYYY').businessAdd(numDays)._d;
                        } else {
                            item.minDate = dateMinEnd.setDate(dateMinEnd.getDate() + numDays);
                        }

                    } else if (item.dateRules.validateOn == 'before') {
                        if (item.dateRules.businessDays) {
                            item.minDate = date_moment_tool(dateMinEnd.toLocaleDateString(), 'MM-DD-YYYY').businessSubtract(numDays)._d;
                        } else {
                            item.minDate = dateMinEnd.setDate(dateMinEnd.getDate() - numDays);
                        }
                    }
                    if (formField.default_value && new Date(formField.default_value) > new Date(item.minDate)) {
                        formField.default_value = new Date(item.minDate).toISOString();
                    }
                }
                item.$validators = {
                    isValidEndDate: function(value, formValue, model, form, parentForm) {
                        if (value) {
                            let startDateControl = (parentForm.$error.isValidStartDate)?parentForm.$error.isValidStartDate[0]:((parentForm.$$success.isValidStartDate)?parentForm.$$success.isValidStartDate[0]:null);
                            let starDateVal = (startDateControl!==null && startDateControl.$viewValue)?startDateControl.$viewValue:model.start_date;
                            // new Data('2024-05-08') might equal Tue May 07 2024 20:00:00 GMT-0400 (Eastern Daylight Time)
                            // new Data('2024-05-08 00:00:00') might equal Wed May 08 2024 00:00:00 GMT-0400 (Eastern Daylight Time)
                            if (starDateVal && typeof starDateVal == 'string' && starDateVal.indexOf(':') == -1) {
                                starDateVal = starDateVal + ' 00:00:00';
                            }
                            if(form.dateRules && (
                                form.dateRules.dependency == 'orderStartDate' ||
                                form.dateRules.dependency == 'lineItemStartDate' ||
                                form.dateRules.dependency == 'flightStartDate'
                            )) {
                                if(starDateVal) {
                                    let startDate = new Date(starDateVal);
                                    let endDate = new Date(value);
                                    const diffTime = Math.abs(endDate - startDate);
                                    const numDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                    if(form.dateRules.numDays > numDays) {
                                        form.validationMessage.default = form.fromPage +
                                            " date rules are not satisfied, too close to the start date";
                                        return false;
                                    }
                                }
                            }
                            if (starDateVal && new Date(starDateVal) > new Date(value)) {
                                return false;
                            }
                            //Line Item start and End Days will always be dependent on order start and end dates.
                            let orderStartDateSatisfied = true;
                            if (form.fromPage == 'lineItem' && form.orderStartDate && form.orderEndDate) {
                                if (typeof form.orderEndDate === 'string' && !form.orderEndDateIsRollupTarget) {
                                    const parts = form.orderEndDate.split('-');
                                    let endDate = new Date(parts[0], parts[1] - 1, parts[2]);
                                    if (new Date(value).setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Line item end date cannot be after the order end date";
                                        }
                                        return false;
                                    }
                                }
                                if (typeof form.orderStartDate === 'string' && starDateVal && !form.orderStartDateIsRollupTarget) {
                                    const sdParts = form.orderStartDate.split('-');
                                    let startDate = new Date(sdParts[0], sdParts[1] - 1, sdParts[2]);
                                    const edParts = form.orderEndDate.split('-');
                                    let endDate = new Date(edParts[0], edParts[1] - 1, edParts[2])
                                    if (new Date(starDateVal).setHours(0, 0, 0, 0) < startDate.setHours(0, 0, 0, 0)) {
                                        orderStartDateSatisfied = false;
                                    } else if (new Date(starDateVal).setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0)) {
                                        orderStartDateSatisfied = false;
                                    }
                                }
                            } /* else if (form.fromPage == 'flight' && form.lineItemEndDate) {
                                if (typeof form.lineItemEndDate === 'string') {
                                    var parts = form.lineItemEndDate.split('-');
                                    var endDate = new Date(parts[0], parts[1] - 1, parts[2]);
                                    if (new Date(value).setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0)) {
                                        if (form && form.validationMessage) {
                                            form.validationMessage.default = "Flight end date cannot be after the line item end date";
                                        }
                                        return false;
                                    }
                                }
                            } */

                            //reset startDate
                            if(startDateControl!==null && starDateVal){
                                if(new Date(value) >= new Date(starDateVal) && orderStartDateSatisfied){
                                    startDateControl.$setValidity('isValidStartDate', true, startDateControl);
                                    if(!model.start_date){
                                        model.start_date = new Date(starDateVal);
                                    }
                                }else{
                                    startDateControl.$setValidity('isValidStartDate', false, startDateControl);
                                }
                            }
                        }
                        return true;
                    }
                }
            }
        }

        if (formField.required == '1') {
            item.labelHtmlClass = item.labelHtmlClass + " required";
            item.isRequired = true;
        } else {
            item.isRequired = false;
        }

        if (formField.help_text && formField.help_text.length !== 0) {
            //item.description = formField.help_text;
            item.helpText = formField.help_text;
        }
        // Destroy Strategy needs to be retained for sales region id for order creation
        if (formField.field_name == 'sales_region_id') {
            item.destroyStrategy = 'retain';
        }

        // Set default values for empty field
        // The key is not add or edit form, but model[model[formField.field_name] is undefined or not
        if (angular.isUndefined(model[formField.field_name])) {
            //automatically select the value if there is only one.
            if (formField.lookup_content?.length == 1 && formField.field_name != 'client_id') {
                let lookup_value = formField.lookup_content[0].lookup_value;
                if(formField.input_type == "multiselect-custom") {
                    let lookupData = [];
                    lookupData.push({
                        label: lookup_value,
                        value: lookup_value
                    })
                    model[formField.field_name] = lookupData;

                } else if (formField.input_type == "multiselect") {
                    model[formField.field_name] = [lookup_value];
                } else if (formField.input_type == "select") {
                    model[formField.field_name] = lookup_value;
                }
            } else if (formField.input_type == "select") {
                model[formField.field_name] = "";
            }

            if (!_.isEmpty(formField.default_value)) {
                item.default_value = setFieldDefaultValue(formField, model);
            }
        } else {
            if (formField.input_type == 'multiselect-custom') {
                const fieldVals = model[formField.field_name];
                let fieldValues = [];
                if(_.isArray(fieldVals)) {
                    _.each(fieldVals, function(fieldVal) {
                        fieldValues.push({
                            label: fieldVal, value: fieldVal
                        });
                    })
                    model[formField.field_name] = fieldValues;
                }
            }
            if (formField.input_type == 'select2') {
                const fieldVal = model[formField.field_name];
                if (isObject(fieldVal)) {
                    const fieldId = fieldVal.id;
                    model[formField.field_name] = {id: fieldId, key: fieldId, text: fieldId};
                } else {
                    model[formField.field_name] = {id: fieldVal, text: fieldVal};
                }
            }
            if (formField.input_type == "textarea" && String(model[formField.field_name]).substring(0,3) !== "<p>") {
                model[formField.field_name] = '<p>' + model[formField.field_name] + '</p>';
            }
            item.default_value = angular.copy(model[formField.field_name]);
        }

        return item;
    };

    const setFieldDefaultValue = function(formField, model) {
        let default_value = formField.default_value;
        const specail_fields = [
            'DFP',
            'geo-location',
            "google-ads-aud-targeting",
            "dfp-frequency",
            "devices",
            "dfp_ad_units",
            "connection",
            "mobile-app",
            "device-capability",
            "facebook-ads-location",
            "snapchat-ads-location",
            "xandr-invest-location",
            "pinterest-geo-location",
            "facebookAds-frequency-controls",
            "snapChat-frequency-controls",
            "xandrInvest-frequency-controls",
            "tritonAds-frequency-controls",
            "pinterestAds-frequency-controls",
            "custom-macro-mapping",
            "custom-macro-mapping-2",
            "geo-targeting-triton",
            "seed-list-macros",
            "pos-matchback-details",
            "triton-creative-management",
            "linkedin-geo-targeting",
            "tiktok-geo-targeting",
        ];
        if (formField.input_type == 'timeselect') {
            if (formField.cascading_field_name && model[formField.field_name]) {
                default_value = model[formField.field_name];
                default_value = default_value.toLocaleTimeString();
            }
            if (String(default_value).indexOf(":") > 0) {
                let timeObj = new Date();
                let timeData = String(default_value).split(" ");
                let timeVal = String(timeData[0]).split(":");
                timeVal[0] = (timeData[1] === "PM") ? parseInt(timeVal[0]) + 12 : timeVal[0];
                timeObj = new Date(timeObj.getFullYear(), timeObj.getMonth(), timeObj.getDate(), parseInt(timeVal[0]), parseInt(timeVal[1]), 0);
                model[formField.field_name] = timeObj;
            }
        } else if (formField.data_type == 'date') {
            default_value = parseDateDefaultValue(default_value, model);
            if (formField.cascading_field_name && model[formField.field_name]) {
                default_value = $filter('date')(model[formField.field_name], 'yyyy-MM-dd');
            }
            let dateVal = String(default_value);
            if (dateVal.indexOf("T") > 0) {
                dateVal = dateVal.split("T")[0];
            }
            dateVal = dateVal.split("-");
            if (default_value) {
                model[formField.field_name] = new Date(parseInt(dateVal[0]), parseInt(dateVal[1]) - 1, parseInt(dateVal[2]), 0, 0, 0);
            }
        } else if (formField.input_type == 'multiselect') {
            if (formField.cascading_field_name && model[formField.field_name]) {
                default_value = JSON.stringify(model[formField.field_name]);
            }
            model[formField.field_name] = JSON.parse(default_value).length > 0 ? JSON.parse(default_value) : model[formField.field_name];
        } else if (formField.input_type == 'multiselect-custom') {
            if (formField.cascading_field_name && model[formField.field_name]) {
                default_value = JSON.stringify(model[formField.field_name]);
            }
            let modelObj = [];
            if (JSON.parse(default_value) !== "") {
                let parsedDefaultValues = JSON.parse(default_value);
                _.each(parsedDefaultValues, function (value) {
                    modelObj.push({
                        label: value,
                        value: value
                    });
                })
                model[formField.field_name] = modelObj;
            } else {
                model[formField.field_name] = [];
            }
        } else if (formField.input_type == 'checkbox') {
            model[formField.field_name] = (formField.default_value == "1" || formField.default_value === true) ? true : false;
        } else if (specail_fields.indexOf(formField.input_type) > -1) {
            if (typeof formField.default_value === 'object') {
                model[formField.field_name] = JSON.stringify(formField.default_value);
            } else {
                model[formField.field_name] = formField.default_value;
            }
        } else {
            model[formField.field_name] = formField.default_value;
        }

        return model[formField.field_name];
    }

    let parseDateDefaultValue = function(default_value, model) {
        let value = '';
        try {
            value = JSON.parse(default_value);
        } catch (e) {
            value = default_value
        }
        if ((typeof value) == 'object') {
            let date_moment_tool = require('moment-business-days');
            let date = new Date();
            let calendarDays = 0;
            switch (value.dateOption) {
                case 'Today':
                    calendarDays = 0;
                    date.setDate(date.getDate() + calendarDays);
                    break;
                case 'Tomorrow':
                    calendarDays = 1;
                    date.setDate(date.getDate() + calendarDays);
                    break;
                case 'Yesterday':
                    calendarDays = -1;
                    date.setDate(date.getDate() + calendarDays);
                    break;
                case 'Next week':
                    calendarDays = 7;
                    date.setDate(date.getDate() + calendarDays);
                    break;
                case 'Next month':
                    const lastDay = new Date(date.getFullYear(), date.getMonth()+1, 0);
                    if (date.getDate() == lastDay.getDate()) {
                        date = new Date(date.getFullYear(), date.getMonth()+2, 0);
                    } else {
                        date = new Date(date.getFullYear(), date.getMonth()+1, date.getDate());
                    }
                    break;
                default:
                    // note: do not set a default value if it's a relative default value
                    if (model[value.dateOption]) {
                        date = new Date(model[value.dateOption]);
                    } else {
                        return null;
                    }
            }
            let numDays = parseInt(value.numDays);
            numDays = isNaN(numDays) ? 0 : numDays;
            const businessDay = value.businessDay;
            // it is still working when numDays is negative
            if (businessDay) {
                date = date_moment_tool(date.toLocaleDateString(), 'MM-DD-YYYY').businessAdd(numDays)._d;
            } else {
                date.setDate(date.getDate() + numDays);
            }
            value = date.toLocaleDateString('en-CA'); // en-CA: YYYY-MM-DD
        }

        return value;
    }

    var getFieldProperties = function(formField, isEditing, preModelData) {
        var fieldProperties = {};
        fieldProperties.title = formField.display_name;
        switch (formField.input_type) {
            case "checkbox":
                fieldProperties.type = "boolean";
                break;
            case "textarea":
                fieldProperties.type = "string";
                break;
            case "textplain-area":
                fieldProperties.type = "string";
                break;
            case "select2":
                fieldProperties.type = "string";
                if (formField.lookup_content) {
                    fieldProperties.items = [];
                    fieldProperties.items = getMultiSelectInputContent(formField.lookup_content);
                    // Set empty option for select2 field when field lookup content is empty
                    if (fieldProperties.items.length == 0) {
                        fieldProperties.items = [
                            {
                                label:'',
                                value:'',
                            },
                        ];
                    }
                }
                break;
            case "multiselect":
                fieldProperties.type = "array";
                fieldProperties.format = "uiselect";
                if (formField.lookup_content) {
                    fieldProperties.items = [];
                    fieldProperties.items = getMultiSelectInputContent(formField.lookup_content);
                    if(formField.enable_type_ahead == "1" && preModelData && preModelData[formField.field_name]){
                        _.each(preModelData[formField.field_name], function(item){
                            var itemLabel = (item[1])?item[1]:item;
                            fieldProperties.items.push({
                                value: itemLabel,
                                label: itemLabel
                            });
                        });
                    }
                }
                break;
            case "multiselect-custom":
                fieldProperties.type = "array";
                fieldProperties.format = "uiselect";
                if (formField.lookup_content) {
                    fieldProperties.items = [];
                    fieldProperties.items = getMultiSelectInputContent(formField.lookup_content);
                }
                break;
            case "file":
                fieldProperties.type = "dfFile";
                break;
            case "custom_file":
                fieldProperties.type = "dfFile";
                break;
            case "creative":
                fieldProperties.type = "creative";
                break;
            case "timeselect":
                fieldProperties.type = "time";
                break;
            case "calculated":
                fieldProperties.type = "string";
                break;
            case "geo-location":
            case "location-picker":
            case "location-picker-fb":
            case "location-targeting":
            case "ad-group":
            case "google-ads-bidding":
            case "facebook-create-ads":
            case "shopping_adgroup_singleproduct":
            case "shopping_adgroup_multiproduct":
            case "DFP":
            case "day-parting":
            case "age-targeting":
            case "snap-chat-age-targeting":
            case "dfp-frequency":
            case "facebookAds-frequency-controls":
            case "snapChat-frequency-controls":
            case "xandrInvest-frequency-controls":
            case "pinterestAds-frequency-controls":
            case "tritonAds-frequency-controls":
            case "custom-macro-mapping":
            case "custom-macro-mapping-2":
            case "seed-list-macros":
            case "pos-matchback-details":
            case "google-ads-aud-targeting":
            case "devices":
            case "device-capability":
            case "dfp_ad_units":
            case "multiple-mappings":
            case "connection":
            case "mobile-app":
            case "inventory-filter":
            case "facebook-ads-location":
            case "snapchat-ads-location":
            case "metric-select":
            case "content-links":
            case "bridge-email-test":
            case "xandr-invest-location":
            case "pinterest-geo-location":
            case "links-and-main-cta":
            case "final-approval":
            case "facebook-page-id":
            case "geo-targeting-triton":
            case "triton-creative-management":
            case "linkedin-geo-targeting":
            case "tiktok-geo-targeting":
                fieldProperties.type = "json";
                break;
            default:
                fieldProperties.type = "string";

                if (formField.lookup_content) {
                    fieldProperties.enum = getSelectInputContent(formField.lookup_content);
                }

                if (formField.field_name == 'client_id' && formField.lookup_content && formField.lookup_content.length == 0) {
                    fieldProperties.description = "*There are no clients for this business unit";
                }

                if (formField.field_name == 'sales_region_id') {
                    fieldProperties.readonly = true;
                }
        }

        if(formField && formField.is_editable) {
            fieldProperties.readonly = false;
            if(formField.is_editable == "disable") {
                fieldProperties.readonly = true;
            } else if(isEditing && formField.is_editable == "add") {
                fieldProperties.readonly = true;
            } else if(!isEditing && formField.is_editable == "edit") {
                fieldProperties.readonly = true;
            }
        }

        if (formField.data_type == 'date') {
            fieldProperties.type = "object";
        }

        return fieldProperties;
    };

    function makeCreativeFieldsNotRequiredIfCreativesAlreadyExistAndReturnRealCreativeFilenames(formFields, preModelData, creatives) {
        // One problem we face with creatives is that they contain both files associated to "file" fields, as well
        // as creatives themselves associated with "creative" fields.  So we need to remove the "file" ones to have only
        // the real creatives left.
        if (!creatives || creatives.length === 0) {
            return [];
        }
        const allCreativeFileNames = creatives.map(x=>x['file_name']);
        let fileCreatives = [];
        _.each(formFields, function(field) {
            if (field.input_type == 'file') {
                // Each file field can contain several files.
                const fieldFileNames = preModelData.hasOwnProperty(field.field_name) ? preModelData[field.field_name] : [];
                _.each(fieldFileNames, function(fileEntry) {
                    fileCreatives.push(fileEntry['file_name']);
                });
            }
        });
        const realCreativeFileNames = _.difference(allCreativeFileNames, fileCreatives);
        // If any creatives are left, it means we should not "require" creative fields on form update, so that the
        // operator does not have to enter other creatives if some are already there.
        if (realCreativeFileNames.length > 0) {
            _.each(formFields, function(field) {
                if (field.input_type == 'creative') {
                    field.required = '0';
                }
            });
        }
        return realCreativeFileNames;
    }

    var getSelectInputContent = function(lookupContent) {
        var inputContent = [];
        inputContent.push("");

        for (var x = 0; x < lookupContent.length; x++) {
            var content = lookupContent[x];
            inputContent.push(content.lookup_value);
        }
        return inputContent;
    };

    var getMultiSelectInputContent = function(lookupContent) {
        var inputContent = [];

        for (var x = 0; x < lookupContent.length; x++) {
            var content = lookupContent[x];
            var item = {};
            item.value = content.lookup_value;
            item.label = content.lookup_value;
            inputContent.push(item);
        }
        return inputContent;
    };

    var getRequiredFields = function(fieldId, fromPage) {
        var deferred = $q.defer();
        FormFactory.calculatedFields().get({
            'requiredFields': 'requiredFields',
            'fieldId': fieldId,
            'fieldType': fromPage
        }).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.calcField);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting required Fields " + fieldId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.computeHighestDisplayOrderInGroup = function(fields, groupId) {
        let highestDisplayOrder = 0;
        _.each(fields, function(field) {
            if (field.group_id == groupId) {
                highestDisplayOrder = Math.max(highestDisplayOrder, field.display_order);
            }
        });
        return highestDisplayOrder + 1;
    }

    service.groupCanBeDeleted = function(groupId, fields) {
        let fieldsPresent = false;
        _.each(fields, function(field) {
            if (field.group_id == groupId) {
                fieldsPresent = true;
            }
        });
        return !fieldsPresent;
    }

    service.calculate = function(params) {
        var deferred = $q.defer();
        FormFactory.calculatedFields().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.calcResult);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting required Fields " + fieldId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Note that this is used for orders, tasks, and flights.
    service.calculateOrder = function(params) {
        var deferred = $q.defer();
        FormFactory.calculatedOrderFields().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.calcResult);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting required Fields " + fieldId);
            deferred.reject();
        });
        return deferred.promise;
    };

    /**
     * Reorder calculate queue so that dependencies are ahead of fields that depend on them. Dependencies are fields
     * that other formulas depend on. They must be calculated before those that require them.
     * Note that the input elements are formatted like this:
     *
     * Array(2)
     * 0: "123,124"
     * 1: "124,120,121"
     *
     * This is an array of strings containing comma-seperated field ids.  The first field id of a given string is the
     * calculated field id, and the remaining ids are the required field ids from the formula, which may or not be
     * *calculated* field ids themselves.  When they are calculated field ids themselves, they are a dependant calculated
     * field and should be computed before the calculated field that uses it.
     *
     * @param calQueue This is an array of comma-separated field ids
     * @return same calQueue elements, but ordered so that dependencies are before the fields that use them
     */
    service.reorderCalQueue = function(calQueue) {
        let calcArray = [];
        let reorderedArray = [];
        let reorderedFieldIds = [];
        let calcFieldIds = [];
        // Create an array indexed by each calculated fieldId, contain an array of its required fieldIds and also the
        // original fieldIds (wrapped into an object).
        _.each(calQueue, function(fieldIds) {
            const dataArray = fieldIds.split(',');
            const fieldId = dataArray.shift();
            calcArray.push({fieldId: fieldId, requiredFieldIds: fieldIds, dataArray: dataArray});
            calcFieldIds.push(fieldId);
        });

        const maxLoopCount = 10;  // Protect against infinite loops
        let loopCount = 0;
        // Loop backwards since we're removing elements (using splice).
        while (calcArray.length > 0 && loopCount++ < maxLoopCount) {
            for (let i = calcArray.length - 1; i >= 0; --i) {
                const requiredCalcFieldIds = _.intersection(calcArray[i].dataArray, calcFieldIds);
                // If we have calculated required fields that we haven't seen yet, wait until the next iteration, because
                // we want these required calculated fields to be computed first, before the current element. In other
                // words, we want calculated fields that are used by OTHER calculated fields to be computed first.
                if (requiredCalcFieldIds.length === 0 || (_.difference(requiredCalcFieldIds, reorderedFieldIds)).length === 0) {
                    reorderedArray.push(calcArray[i].requiredFieldIds);
                    reorderedFieldIds.push(calcArray[i].fieldId);
                    calcArray.splice(i, 1);
                } // Else hope it's there in the next while iterations
            }
        }
        return reorderedArray;
    };

    service.getDataTypes = function(contentTypeId = 0) {
        var params = {
            'contentTypeId': contentTypeId
        };
        var deferred = $q.defer();
        FormFactory.dataTypes().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.dataTypes);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting data types");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getInputTypes = function(contentTypeId = 0) {
        var params = {
            'contentTypeId': contentTypeId
        };
        var deferred = $q.defer();
        FormFactory.inputTypes().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.inputTypes);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting input types");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getGoalAssociationTypes = function() {
        var deferred = $q.defer();
        FormFactory.goalAssociationTypes().get().$promise.then(function(data) {
            if (data) {
                deferred.resolve(data);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting goal association types");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.getProductRollupTargets = function(productId) {
        const params = {
            'productId': productId
        };
        let deferred = $q.defer();
        FormFactory.productRollupTargets().get(params).$promise.then(function(data) {
            if (data && data.fieldNames) {
                deferred.resolve(data.fieldNames);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting product rollup targets");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.getClientRollupTargets = function() {
        let deferred = $q.defer();
        FormFactory.clientRollupTargets().get().$promise.then(function(data) {
            if (data && data.fieldNames) {
                deferred.resolve(data.fieldNames);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting client rollup targets");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.getOrderRollupTargets = function() {
        let deferred = $q.defer();
        FormFactory.orderRollupTargets().get().$promise.then(function(data) {
            if (data && data.fieldNames) {
                deferred.resolve(data.fieldNames);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting order rollup targets");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.getTaskRollupTargets = function(formId) {
        let deferred = $q.defer();
        var params = {
            'formId': formId
        };
        FormFactory.taskRollupTargets().get(params).$promise.then(function(data) {
            if (data && data.fieldNames) {
                deferred.resolve(data.fieldNames);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting task rollup targets");
            deferred.reject();
        });
        return deferred.promise;
    }

    service.getContentTypes = function() {
        var deferred = $q.defer();
        FormFactory.contentTypes().get().$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.contentTypes);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting input types");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getFormFields = function(formId, clusterId, showAll) {
        var deferred = $q.defer();
        var params = {
            'formFields': 'formFields',
            'formId': formId,
            'clusterId': clusterId
        };

        if (showAll) {
            params.showAll = 1;
        }

        FormFactory.formFields().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.formFields);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting form fields for form Id " + formId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.saveFormFields = function(params) {
        var deferred = $q.defer();
        FormFactory.formFields().save({
            'formFields': 'formField'
        }, params).$promise.then(function(data) {
            if (data.formField) {
                deferred.resolve(data.formField);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("Error saving form fields");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateFormFields = function(params) {
        var deferred = $q.defer();
        FormFactory.formFields().update({
            'formFields': 'formField'
        }, params).$promise.then(function(data) {
            if (data.formField) {
                deferred.resolve(data.formField);
            } else {
                deferred.reject(data);  // NICO: was data.errors
            }
        }, function(response) {
            console.log("Error updating form fields");
            deferred.reject();
        });
        return deferred.promise;
    };

     //update formlist fields display order
     service.updateFormListDisplayOrder = function(params) {
        var deferred = $q.defer();
        var fields = {fields: params};

        FormFactory.formFieldDisplayOrder().post(fields).$promise.then(function(data) {
            if(data.formFields){
                deferred.resolve(data.formFields);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error updating product field display order");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getFormFieldGroups = function(formId, clusterId, showAll = 0) {
        var deferred = $q.defer();
        var params = {
            'formFieldGroups': 'formFieldGroups',
            'formId': formId,
            'showAll': showAll
        };

        if (clusterId) {
            params.clusterId = clusterId;
        }

        FormFactory.formFieldGroups().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.formFieldGroups);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting task form field groups");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.saveFormFieldGroups = function(params) {
        var deferred = $q.defer();
        FormFactory.formFieldGroups().save({
            'formFieldGroups': 'formFieldGroup'
        }, params).$promise.then(function(data) {
            if (data?.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data?.formFieldGroup);
            }
        }, function(response) {
            console.log("Error saving form fields form groups ");
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.updateFormFieldGroups = function(params) {
        var deferred = $q.defer();
        FormFactory.formFieldGroups().update({
            'formFieldGroups': 'formFieldGroup'
        }, params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error updating form field groups");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.exportForm = function(formId) {
        let deferred = $q.defer();
        $http.get(AppConfig.IO_API_URL + 'form/export', {
            params: {'id': formId}}).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            console.log("error exporting form");
            deferred.reject(error);
        });
        return deferred.promise;
    };

    service.importForm = function(customFile) {
        var deferred = $q.defer();
        Upload.upload({
            url: AppConfig.IO_API_URL + 'form/import',
            file: customFile
        }).success(function(data, status, headers, config) {
            if (data.result){
                deferred.resolve(data.result);
            }else{
                deferred.reject(data.errors);
            }
        }).error(function(error) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.deleteFormFieldGroup = function(groupId) {
        var deferred = $q.defer();
        var params = {
            'id': groupId
        }
        FormFactory.formFieldGroup().delete(params).$promise.then(function(data) {
            deferred.resolve(data.formFieldGroup);
        }, function(response) {
            console.log("Error deleting form field group");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTypesForForm = function(formId) {
        var deferred = $q.defer();
        var params = {
            'formId': formId
        };

        FormFactory.typesForForm().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.lookupTypes);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting types for form");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getFormContents = function(formId, lookupTypeId, clusterId) {
        var deferred = $q.defer();
        var params = {
            'contents': 'contents',
            'formId': formId,
            'lookupTypeId': lookupTypeId
        };

        if (clusterId) {
            params.clusterId = clusterId;
        }

        FormFactory.formContents().get(params).$promise.then(function(data) {
            if (data) {
                deferred.resolve(data.lookupContent);
            } else {
                deferred.reject();
            }
        }, function(response) {
            console.log("Error getting form contents");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.addFormContents = function(params) {
        var deferred = $q.defer();
        FormFactory.formContents().save({
            'contents': 'addFormContents'
        }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error adding form lookup contents");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateFormContents = function(params) {
        var deferred = $q.defer();
        FormFactory.formContents().update({
            'contents': 'updateFormContents'
        }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error updating form lookup contents");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteFormContents = function(params) {
        var deferred = $q.defer();
        FormFactory.formContents().delete({
            'contents': 'deleteFormContents',
            'formId': params.formId,
            'lookupTypeId': params.lookupTypeId,
            'clusterId': params.clusterId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting form lookup contents");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.processCustomFile = function(entityName, entityId, fieldName, customFiles, taskAssignmentId) {
        // Some files might have already been there (when editing a form), so only keep new uploads.
        // These will be of File type.
        const actualCustomFiles = customFiles.filter(file => file instanceof File);
        let numFilesToUpload = (!actualCustomFiles || actualCustomFiles.length === 0) ? 0 : actualCustomFiles.length;
        const deferred = $q.defer();

        let uploadParameters = {
            entityName: entityName,
            entityId: entityId,
            fieldName: fieldName
        };

        if (taskAssignmentId != 0) {
            uploadParameters.taskAssignmentId = taskAssignmentId;
        }
        let deleteProcessed = false;
        let itemsProcessed = 0;
        let itemsSuccessfullyUploaded = 0;
        for (let i = 0; i < numFilesToUpload; i++) {
            const currentFile = actualCustomFiles[i];
            Upload.upload({
                url: AppConfig.IO_API_URL + 'customModule/processFile',
                fields: uploadParameters,
                file: currentFile
            }).success(function (data, status, headers, config) {
                if (data.result && data.result.errors) {
                    alertErrors(data.result.errors);
                } else if (data.errors) {
                    alertErrors(data.errors);
                } else {
                    // No errors for this file
                    itemsSuccessfullyUploaded++;
                }
                // Only resolve (or reject) the promise when a response has been received for all files, and delete
                // has been processed (see below). Make it a success if at least one file upload was successful.
                if ((++itemsProcessed === numFilesToUpload) && deleteProcessed) {
                    return (itemsSuccessfullyUploaded > 0) ? deferred.resolve() : deferred.reject();
                }
            }).error(function (error) {
                alertErrors(error);
                if ((++itemsProcessed === numFilesToUpload) && deleteProcessed) {
                    return (itemsSuccessfullyUploaded > 0) ? deferred.resolve() : deferred.reject();
                }
            });
        }

        let currentFiles = [];
        customFiles.forEach(function(oneFile) {
            let fileName = oneFile.file_name ? oneFile.file_name : oneFile.name;
            currentFiles.push(fileName);
        });
        let deleteParams = {
            entityName: entityName,
            entityId: entityId,
            fieldName: fieldName,
            fileNames: currentFiles
        };
        if (taskAssignmentId != 0) {
            deleteParams.taskAssignmentId = taskAssignmentId;
        }

        FormFactory.processFileDelete().save(deleteParams).$promise.then(function() {
            deleteProcessed = true;
            if ((itemsProcessed === numFilesToUpload)) {
                return (numFilesToUpload == 0 || itemsSuccessfullyUploaded > 0) ? deferred.resolve() : deferred.reject();
            }
        }, function() {
            console.log("Error processing custom files to delete");
            deleteProcessed = true;
            if ((itemsProcessed === numFilesToUpload)) {
                return deferred.reject();
            }
        });

        return deferred.promise;
    };

    const alertErrors = function(errors) {
        if (Array.isArray(errors)) {
            errors.forEach(error => $ioAlert.show("Error!", error, 'error'));
        } else {
            if (errors) {
                $ioAlert.show("Error!", errors, 'error');
            }
        }
    };

    service.cloneForm = function(formId, formName) {
        var deferred = $q.defer();
        var params = {
            'id': formId,
            'name': formName
        };

        FormFactory.clone().save(params).$promise.then(function(data) {
            service.formId = data.new_id;
            deferred.resolve();
        }, function(response) {
            console.log("error cloning form");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.cloneLookupContent = function(params) {
        var deferred = $q.defer();
        FormFactory.formContents().save({
            'contents': 'cloneFormLookupContents'
        }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error cloning form lookup contents");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.currencyFormating = function(eleVal, trimming) {
        if (eleVal) {
            let sign = eleVal.charAt(0) === '-' ? '-' : '';

            eleVal = eleVal.replace(/,/g, "");
            if (trimming === true) {
                eleVal = parseFloat(eleVal).toFixed(2);
            }
            var numVal = eleVal.split(".");
            if (numVal.length >= 2) {
                numVal[0] = numVal[0].replace(/[^0-9]/gi, '');
                numVal[1] = numVal[1].replace(/[^0-9]/gi, '');
                numVal[0] = numVal[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                numVal[1] = numVal[1].substring(0, 2);
                eleVal = numVal[0] + "." + numVal[1];
            } else {
                eleVal = eleVal.replace(/[^0-9]/gi, '');
                eleVal = eleVal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            }
            if (eleVal && eleVal.contains('$')) {
                return sign + eleVal;
            } else {
                var str = sign + "$";
                eleVal = str.concat(eleVal);
            }
        }
        return eleVal;
    }

    service.numberFormating = function(eleVal, round = -1) {
        if (eleVal) {
            let sign = eleVal.charAt(0) === '-' ? '-' : '';

            eleVal = eleVal.replace(/,/g, "");
            if (round > -1) {
                eleVal = parseFloat(eleVal).toFixed(round);
            }
            let numVal = eleVal.split(".");
            if (numVal.length >= 2) {
                numVal[0] = numVal[0].replace(/[^0-9]/gi, '');
                numVal[1] = numVal[1].replace(/[^0-9]/gi, '');
                numVal[0] = numVal[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                eleVal = numVal[0] + "." + numVal[1];
            } else {
                eleVal = eleVal.replace(/[^0-9]/gi, '');
                eleVal = eleVal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            }

            eleVal = sign + eleVal
        }
        return eleVal;
    }

    /*
     * Instance level hide line item
     * TODO: Need to move to a different service
     */
    service.saveToggleLineItem = function(params) {
        var deferred = $q.defer();
        FormFactory.instanceSettings().save({ 'activities': 'activities' }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    }

    service.updateToggleLineItem = function(params) {
        var deferred = $q.defer();
        FormFactory.instanceSettings().update({ 'activities': 'activities' }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    service.getInstanceSettings = function(type) {
        var deferred = $q.defer();
        FormFactory.instanceSettings().get({
            'instanceSettingType': type
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    service.getInstanceSettingArray = function(params) {
        var deferred = $q.defer();
        FormFactory.instanceSettingArray().get({
            'instanceSettingTypeArray[]': params
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    service.getLineitemPushConnectorClientAccountMapping = function(clusterId = null, clientId = null, serviceId = null) {
        var deferred = $q.defer();
        FormFactory.PushConnectorClientAccountMapping().get({clusterId: clusterId, clientId: clientId, serviceId: serviceId}).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    service.getAllTaskForms = function () {
        var deferred = $q.defer();
        FormFactory.getAllTaskForms().get().$promise.then(function (response) {
            if(response.forms){
                deferred.resolve(response.forms);
            }else{
                deferred.reject(response);
            }
        }, function (response) {
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.getAllOrderForms = function () {
        var deferred = $q.defer();
        FormFactory.getAllOrderForms().get().$promise.then(function (response) {
            if(response.forms){
                deferred.resolve(response.forms);
            }else{
                deferred.reject(response);
            }
        }, function (response) {
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.getAllClientForms = function () {
        var deferred = $q.defer();
        FormFactory.getAllClientForms().get().$promise.then(function (response) {
            if(response.forms){
                deferred.resolve(response.forms);
            }else{
                deferred.reject(response);
            }
        }, function (response) {
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.getAllFlightForms = function () {
        var deferred = $q.defer();
        FormFactory.getAllFlightForms().get().$promise.then(function (response) {
            if(response.forms){
                deferred.resolve(response.forms);
            }else{
                deferred.reject(response);
            }
        }, function (response) {
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.getOrderAndTaskList = function (clusterId, showAll) {
        var deferred = $q.defer();
        var params = {
            'clusterId': clusterId,
            'showAll': showAll
        };
        FormFactory.orderAndTaskList().get(params).$promise.then(function (response) {
            if(response.forms){
                deferred.resolve(response.forms);
            }else{
                deferred.reject(response);
            }
        }, function (response) {
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.saveOrderAndTaskForm = function (params) {
        var deferred = $q.defer();
        FormFactory.orderAndTaskForm().save(params).$promise.then(function (data) {
            if (data)
                deferred.resolve(data);
            else
                deferred.reject('error');
        }, function (response) {
            console.log("error saving form");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateOrderAndTaskForm = function (params) {
        var deferred = $q.defer();
        FormFactory.orderAndTaskForm().update(params).$promise.then(function (data) {
            if (data)
                deferred.resolve(data);
            else
                deferred.reject('error');
        }, function (response) {
            console.log("error updating form");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteConversionTracker = function (obj) {
        var deferred = $q.defer();
        FormFactory.deletePixel().update(obj).$promise.then(function (data) {
            if (data)
                deferred.resolve(data);
            else
                deferred.reject('error');
        }, function (response) {
            console.log("error deleting pixel");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.editConversionTracker = function (obj) {
        var deferred = $q.defer();
        FormFactory.editPixel().update(obj).$promise.then(function (data) {
            if (data)
                deferred.resolve(data);
            else
                deferred.reject('error');
        }, function (response) {
            console.log("error updating pixel data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getGoalServices = function() {
        var deferred = $q.defer();

        FormFactory.getGoalServices().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getSmartCampaigns = function() {
        var deferred = $q.defer();

        FormFactory.getSmartCampaigns().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getServiceMetrics = function(serviceId) {
        var deferred = $q.defer();
        var params = {
            'serviceId': serviceId,
            'format': '!percent',
            'ignore_reporting_profile': true,
            'is_average': false,
            'is_metric': true,
            'metadata': true,
            'sort': 'label',
            'sql': 1
        };

        FormFactory.getServiceMetrics().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getAudience = function(id) {
        const deferred = $q.defer();
        const params = {
            'id': id
        };

        FormFactory.getAudience().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getServiceDataViews = function(serviceId) {
        var deferred = $q.defer();
        var params = {
            'serviceId': serviceId,
            'sql': 1
        };

        FormFactory.getServiceDataViews().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.setContentLinks = function(contentLinks, showUnsub) {
        let deferred = $q.defer();
        let params = {
            'contentLinks': contentLinks
        };

        FormFactory.setContentLinks().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.orderIdsUsingFormField = function(formFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': formFieldId
        };

        FormFactory.orderIdsUsingFormField().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting list of order ids using form field id " + formFieldId);
            deferred.reject(response);
        });

        return deferred.promise;
    }

    service.flightIdsUsingFormField = function(formFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': formFieldId
        };

        FormFactory.flightIdsUsingFormField().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting list of flight ids using form field id " + formFieldId);
            deferred.reject(response);
        });

        return deferred.promise;
    }

    service.recalculateAllOrders = function(formFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': formFieldId
        };

        FormFactory.recalculateAllOrders().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error recalculating order form field attributes");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.recalculateAllFlights = function(formFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': formFieldId
        };

        FormFactory.recalculateAllFlights().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error recalculating flight form field attributes");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.cloneAllFormLookupContentForClusters = function(sourceClusterId, destClusterIds) {
        let deferred = $q.defer();
        let params = {
            'sourceClusterId': sourceClusterId,
            'destClusterIds': destClusterIds
        };

        FormFactory.cloneAllFormLookupContentForClusters().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error cloning all form lookup content");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.isFormFieldEmpty = function(fieldValue) {
        return (_.isArray(fieldValue) && fieldValue.length == 0) ||
            fieldValue === undefined ||
            fieldValue === "" ||
            fieldValue === null ||
            fieldValue === false;
    }

    service.validateSeedListPurple = function(bridgeEmailTest) {
        let deferred = $q.defer();
        let params = {
            'bridgeEmailTest': bridgeEmailTest
        };

        FormFactory.validateSeedListPurple().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.syncAdvertiserSettings = function(flightId) {
        let deferred = $q.defer();
        let params = {'flightId': flightId};

        FormFactory.syncAdvertiserSettings().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject(response);
        });

        return deferred.promise;
    };

    // These are BridgeCorp custom fields.  Please keep the list consistent with that of BridgeVendor.php.
    const ASYNCHRONOUS_FIELD_NAMES = [
        '__banner_validation_status',
        '__320x50_banner_validation_status',
        '__728x90_banner_validation_status',
        '__email_test_validation_status',
        '__seed_validation_status',
        '__test_seed_validation_status',
        '__live_seed_validation_status',
        '__email_people_status',
        '__links',
        '__links_and_main_cta',
        '__has_cta_macro',
        '__macros',
        '__email_macros',
        '__eoa_previews',
        '__creative_uri',
        '__html_validation_status',
        '__has_critical_html_val_errors',
        '__html_validation_errors',
        '__content_links',
        '__generic_product_status',
        '__generic_api_provider_campaign_id',
        '__display_map_status',
        '__pos_matchback_status',
        '__pos_id_details',
        '__response_data_status',
        '__live_seed_list_id',
        '__test_seed_list_id'
    ];

    /**
     * This function determines whether the given form/product fields contain at least one field that could be
     * updated asynchronously via a callback to the backend. This is used to refresh the data via polling, if such
     * a field is found in the form.
     *
     * @param fields Either a form or product fields array to examine
     */
    service.hasAsynchronousFields = function(fields) {
        const fieldNames = fields.map(x=>x['field_name']);
        return fieldNames.some(name => ASYNCHRONOUS_FIELD_NAMES.contains(name));
    }

    service.extractAsynchronousFieldValues = function(entity, eoa_previews = null) {
        let existingValues = {};
        ASYNCHRONOUS_FIELD_NAMES.forEach(function(fieldName) {
            if (entity.hasOwnProperty(fieldName)) {
                existingValues[fieldName] = entity[fieldName];
                // The __eoa_previews gets modified so it's HTML, so if we don't use the original value, it'll always
                // think it was modified when we poll the backend for changes.
                if (fieldName === '__eoa_previews' && eoa_previews != null) {
                    existingValues[fieldName] = eoa_previews;
                }
            }
        });
        return existingValues;
    }

    service.computeUploadingAndDeletedFiles = function(model, form, fields) {
        let uploadingFiles = [];
        let deletedFiles = [];

        _.each(model, function(itemVal, prop) {
            let fieldObj = _.find(fields, {field_name: prop});
            if (fieldObj && fieldObj.input_type == "file" && model[prop]) {
                let oldFileObjList = [];
                for (let k = 0, len = form.length; k < len; k++) {
                    if (form[k].items) {
                        let fileField = _.find(form[k].items, {field_name: prop});
                        if (fileField) {
                            oldFileObjList = fileField.fileObjList ? fileField.fileObjList : [];
                            break;
                        }
                    }
                }

                let currentUploadingFiles = model[prop];
                let currentDeletedFiles = [];
                if (oldFileObjList && oldFileObjList.length > 0) {
                    // newFileObjList is the file list on the form
                    // oldFileObjList is the file list from database
                    // uploadingFileObjs will keep the new files the user added
                    // deleteFiles will keep the files the user removed
                    // We remove the duplicated files between 2 arrays to avoid duplicated file uploading
                    // newFileObjList structure [{ name: val }, { name: val }]
                    // oldListObjList structure [{ attr_id: val, file_name: val}, {attr_id: val, file_name: val}]
                    let newFileObjList = model[prop];
                    let newListSet = new Set(newFileObjList.map(({ name }) => name));
                    let oldListSet = new Set(oldFileObjList.map(({file_name}) => file_name));
                    currentUploadingFiles = newFileObjList.filter(({ name }) => !oldListSet.has( name ));
                    currentDeletedFiles = oldFileObjList.filter(({file_name}) => !newListSet.has(file_name));
                }
                uploadingFiles[prop] = currentUploadingFiles;
                deletedFiles[prop] = currentDeletedFiles;
            }
        });

        return [uploadingFiles, deletedFiles];
    }

    /**
     * This function converts the date string to Date object.
     *
     * @param dateString the date string like 2023-11-27
     */
    service.convertStringToDate = function(dateString) {
        if (dateString && typeof dateString === 'string') {
            const parts = dateString.split('-');
            dateString = new Date(parts[0], parts[1] - 1, parts[2]);
        }
        return dateString;
    }

    /**
     * Get input types which do not need lookup type
     */
    service.inputTypesNoLookupType = function() {
        return [
            'text',
            'textarea',
            'textplain-area',
            'checkbox',
            'calculated',
            'calculated-override',
            'calculate-all',
            'checkbox',
            'currency',
            'percentage',
            'custom_function',
            'custom_file',
            'file',
            'timeselect',
            'creative',
            'rollup-target',
            'custom-macro-mapping',
            'custom-macro-mapping-2',
            'seed-list-macros',
            'pos-matchback-details',
        ];
    }

    /**
     * This function registers all date fields provided in the param form, so that they change value if
     * their default value is set to be another date field.
     * @param form scope form that contains all date fields.
     * @param fields scope.formFields/productFields/flightFields that contains default values for each field.
     * @param model scope.model that can be used to modify the current value of date fields.
     */
    service.registerForDateChanges = function(form, fields, model) {
        let dateItems = [];
        // find all datePicker items
        for (let i=0, len=form.length; i < len; i++) {
            const items = form[i].items;
            let datePickerItems = _.filter(items, {type: 'datePicker'});
            if(datePickerItems.length > 0) {
                dateItems.push(...datePickerItems);
            }
        }

        // set onDateChange method for all datePicker items
        if (dateItems) {
            for (let j =0; j < dateItems.length; j++) {
                let item = dateItems[j];

                item.onDateChange = onDateChange(form, fields, model);
            }
        }
    }

    function onDateChange(scopeForm, fields, model) {
        return function (date, form) {
            let fields_to_update = findDefaultValuesToUpdate(form, fields);

            if (fields_to_update.length > 0) {
                let name_to_update = fields_to_update.map(field => field.field_name);

                _.each(scopeForm, function (form) {
                    _.each(form.items, function (item) {
                        if (name_to_update.contains(item.field_name)) {
                            let angular_date = angular.copy(date);
                            setDefaultDate(item, angular_date, fields_to_update, model);
                        }
                    });
                });
            }
        }
    }

    /**
     * Finds all date fields that uses the modified date field as data source
     *
     * @param form the html form that got changed.
     * @param fields list of all fields that might need to be updated.
     * @returns {*[]}
     */
    function findDefaultValuesToUpdate(form, fields) {
        let fields_to_update = [];
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            // find all the date fields with default date
            if (field.data_type == "date" && field.field_name != form.field_name && field.default_value) {
                // if default date is modifiedDate default date is now new data.
                let default_value_name = JSON.parse(field.default_value).dateOption;

                if (default_value_name == form.field_name) {
                    fields_to_update.push(field);
                }
            }
        }

        return fields_to_update;
    }

    /**
     * Sets the default value of item to the input date. If item's value is its old default value,
     * updates its current value to the new default value.
     *
     * @param item the item that will receive a new default date.
     * @param date the new default date value.
     * @param fields scope.formFields/productFields/flightFields that contains default values for each field.
     * @param model scope.model that can be used to modify the current value of date fields.
     */
    function setDefaultDate(item, date, fields, model) {
        let date_moment_tool = require('moment-business-days');
        let field = fields.find(f => f.field_name == item.field_name);
        let default_value = field ? JSON.parse(field.default_value) : null;
        let numDays = parseInt(default_value.numDays);
        const businessDay = default_value.businessDay ?? false;

        // Specify options for consistent formatting
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };

        if (businessDay) {
            date = date_moment_tool(date.toLocaleDateString('en-CA', options), 'YYYY-MM-DD').businessAdd(numDays)._d;
        } else {
            date = date_moment_tool(date.toLocaleDateString('en-CA', options), 'YYYY-MM-DD').add(numDays, 'd')._d;
        }

        if (String(model[item.field_name]) === String(item.default_value)) {
            model[item.field_name] = date;
        }
        item.default_value = date;
    }

    /*
     * Natural sort the array by id desc for ng-repeat usage
     */
    service.naturalSortByIdDesc = function(a, b) {
        if (a.type == 'string') {
            return b.value - a.value;
        }
    }

    return service;
}]);
